{
  "common": {
    "no_access": "Non hai accesso a questo modulo"
  },
  "settings": {
    "calendar": {
      "calendar_settings": "Impostazioni del calendario",
      "settings": "Impostazioni",
      "select_calendar_type": "Seleziona tipo di calendario",
      "add_new_calendar_group": "Aggiungi nuovo gruppo di calendari",
      "add_new_equipment": "Aggiungi nuova attrezzatura",
      "new_calendar": "Nuovo calendario",
      "calendar_group_description": "Usa i gruppi di calendari per organizzare e raggruppare efficacemente più calendari.",
      "group": "Gruppo",
      "manage_your_calendars_and_groups": "Gestisci i tuoi calendari e gruppi",
      "groups": "Gruppi",
      "create_group": "Crea gruppo",
      "create_calendar": "Crea calendario",
      "calendar_name": "Nome del calendario",
      "group_duration": "Durata del gruppo",
      "calendar_type": "Digita",
      "action": "Azione",
      "round_robin": "A rotazione",
      "event": "Evento",
      "group_name": "Nome del gruppo",
      "room_name": "Nome della sala",
      "group_description": "Descrizione del gruppo",
      "calendar_url": "URL del calendario",
      "calendars": "Calendari",
      "date_updated": "Data di aggiornamento",
      "status": "Stato",
      "action_dropdown": "Elenco a discesa delle azioni",
      "calendar_list": "Servizi associati a",
      "edit": "Modifica",
      "duplicate": "Duplicato",
      "copy_embed_code": "Copia codice di incorporamento",
      "copy_permanent_link": "Copia link permanente",
      "copy_new_slug_link": "Copia link di programmazione",
      "copy_scheduling_link": "Copia link di programmazione (versione precedente obsoleta)",
      "deactivate_calendar": "Disattiva calendario",
      "move_to_group": "Sposta nel gruppo",
      "delete_calendar": "Elimina calendario",
      "delete_group": "Elimina",
      "delete_this_group": "Elimina questo gruppo",
      "activate_calendar": "Attiva calendario",
      "duration": "Durata",
      "multiple_durations": "Diverse opzioni",
      "all": "Tutto",
      "draft": "Bozza",
      "inactive": "Inattivo",
      "active": "Attivo",
      "actions": "attività",
      "rearrange_calendars": "Riorganizza calendari",
      "deactivate_all_calendars_in_group": "Disattiva tutti i calendari del gruppo",
      "activate_all_calendars_in_group": "Attiva tutti i calendari del gruppo",
      "no_groups_found": "La ricerca non ha trovato corrispondenza con alcun gruppo di calendari.",
      "no_groups_in_location": "Gruppo Ordina i tuoi calendari Metti Mi piace Cartella. Aggiungi calendari a un gruppo e Condividi un individuo Link di programmazione, consentendo a Prenotante Seleziona da più calendari.",
      "no_calendars_found": "Inizia a usare il calendario creando un nuovo calendario.",
      "no_calendars_found_search": "La tua ricerca non ha trovato corrispondenza con alcun calendario.",
      "delete_calendar_message": "Stai per eliminare il calendario. Quando premi Elimina, vengono eliminati anche tutti i suoi appuntamenti.",
      "delete_calendar_message_title": "Vuoi eliminare questo calendario?",
      "duplicate_calendar_message": "Stai per duplicare il calendario. In questo modo verrà creato un nuovo calendario con le stesse impostazioni del calendario selezionato.",
      "duplicate_calendar_message_title": "Vuoi duplicare questo calendario?",
      "no_calendars_found_title": "Nessun calendario trovato",
      "no_groups_in_location_title": "Nessun gruppo trovato",
      "delete_group_confirmation_title": "Vuoi eliminare questo gruppo?",
      "delete_group_confirmation": "Vuoi davvero eliminare il gruppo selezionato?",
      "delete_group_confirmation_checkbox_title": "Elimina i calendari e gli appuntamenti associati",
      "delete_group_confirmation_checkbox_description": "Selezionando questa opzione verranno eliminati anche i calendari di questo gruppo, insieme a tutti gli appuntamenti in quei calendari.",
      "group_status_message_title": "{status} gruppo e tutti i calendari associati?",
      "calendar_status_message_title": "Vuoi eseguire l'azione ({status}) per questo calendario?",
      "calendar_status_message": "Stai per eseguire l'azione ({status}) per questo calendario.",
      "group_status_active_message": "Vuoi davvero attivare questo gruppo? Tutti i calendari del gruppo saranno inoltre attivati e disponibili per la prenotazione.",
      "group_status_inactive_message": "Vuoi davvero disattivare questo gruppo? Tutti i calendari del gruppo saranno inoltre disattivati e disponibili per la prenotazione.",
      "coming_soon": "Prossimamente",
      "select": "Seleziona",
      "15mins": "15 minuti",
      "cancel": "Annulla",
      "save": "Salva",
      "create": "Crea",
      "select_calendar_group": "Seleziona un gruppo di calendari",
      "move_calendar_confirmation": "Il link legacy smetterà di funzionare una volta che procederai con questo cambiamento. Confermi selezionando la casella.",
      "previously_called_unassigned": " (Precedentemente chiamato come non assegnato)",
      "scheduling_type": "Scegli il tipo di calendario",
      "scheduling_type_description": "Seleziona a Tipo di calendario per Configurare il tuo calendario e Personalizza come è programmato l'Appuntamento.",
      "service_menu_name": "Nome del menu dei servizi",
      "template": "Modello",
      "select_template": "Seleziona un modello",
      "group_url": "URL del gruppo",
      "template_description": "Ora hai la possibilità di scegliere tra i modelli Classico o Neo per la Vista gruppo.",
      "rooms": "Stanze",
      "rooms_name": "Nome",
      "rooms_description": "Descrizione",
      "rooms_modal_description": "Aggiungi o modifica sala.",
      "rooms_capacity": "Capacità totale",
      "no_rooms_in_location_title": "Nessuna stanza trovata",
      "no_rooms_in_location": "Nessuna stanza trovata in questo luogo",
      "no_equipments_in_location": "Nessuna attrezzatura trovata in questo luogo",
      "equipments": "Attrezzatura",
      "equipment_name": "Nome",
      "equipment_name_search": "Nome dell'attrezzatura",
      "equipment_description": "Descrizione",
      "equipment_modal_description": "Aggiungi o modifica attrezzatura.",
      "add_equipment": "Aggiungi/modifica attrezzatura",
      "add_room": "Aggiungi/modifica stanza",
      "equipment_quantity": "Quantità totale",
      "equipment_outOfService": "Quantità fuori servizio",
      "no_equipments_in_location_title": "Nessun dispositivo trovato",
      "delete_this_equipment": "Elimina questa attrezzatura",
      "delete_this_rooms": "Elimina questa stanza",
      "delete_equipment_confirmation": "Vuoi davvero eliminare questa attrezzatura? Verrà rimossa anche da tutti i calendari collegati.",
      "delete_rooms_confirmation": "Vuoi davvero eliminare questa stanza? Verrà rimossa anche da tutti i calendari collegati.",
      "add_new_calendar_equipments": "Aggiungi nuova attrezzatura",
      "no_equipments_found": "La tua ricerca non ha trovato alcuna attrezzatura.",
      "no_rooms_found": "La tua ricerca non ha trovato alcuna stanza.",
      "add_new_calendar_rooms": "Aggiungi nuova stanza",
      "rooms_disable": "Disabilita stanza",
      "equipments_disable": "Disabilita attrezzatura",
      "equipments_activate": "Attiva attrezzatura",
      "rooms_activate": "Attiva stanza",
      "create_equipments": "Crea attrezzatura",
      "create_rooms": "Crea stanza",
      "select_calendar_rooms_title": "Seleziona calendario",
      "select_calendar_rooms_description": "Puoi selezionare più calendari da associare alle sale.",
      "select_calendar_equipments_title": "Seleziona calendario",
      "select_calendar_equipments_description": "Puoi selezionare un calendario da associare all'attrezzatura.",
      "disable_equipment_title": "Esegui l'azione ({status}) per l'attrezzatura",
      "disable_room_title": "Esegui l'azione ({status}) per la stanza",
      "equipments_status_message": "Vuoi davvero eseguire l'azione ({status}) per questa attrezzatura?",
      "rooms_status_message": "Vuoi davvero eseguire l'azione ({status}) per questa stanza?",
      "calendar_resource_disclaimer": "Questo potrebbe influire sulla disponibilità nei calendari dei servizi associati.",
      "equipment_disclaimer": "Nota: abilitando l'attrezzatura in un secondo momento, essa verrà automaticamente ricollegata ai calendari a cui è associata",
      "room_disclaimer": "Nota: abilitando la stanza in un secondo momento, essa verrà automaticamente ricollegata ai calendari a cui è associata",
      "equipment_tab_name": "Attrezzatura",
      "rooms_tab_name": "Stanze",
      "manage_your_rooms": "Gestisci qui le stanze per la tua attività",
      "manage_your_equipments": "Gestisci qui l'attrezzatura per la tua attività",
      "select_service_calendar_description_equipments": "Puoi selezionare più calendari dei servizi da associare all'attrezzatura.",
      "select_service_calendar_description_rooms": "Puoi selezionare più calendari dei servizi da associare alle sale.",
      "service_menus": "Menu dei servizi",
      "manage_your_calendars_groups_and_service_menus": "Gestisci i tuoi calendari, gruppi e menu dei servizi",
      "new_service_menu": "Crea menu dei servizi",
      "deactivate_service_menu": "Disattiva menu dei servizi",
      "delete_service_menu": "Elimina questo menu dei servizi",
      "delete_service_menu_confirmation": "Vuoi davvero eliminare questo menu dei servizi?",
      "service_menu_status_message_title": "Eseguire l'azione ({status}) per questo menu dei servizi?",
      "service_menu_status_message": "Stai per eseguire l'azione ({status}) per il menu dei servizi.",
      "no_service_menus_in_location_title": "Crea il tuo menu dei servizi personalizzato",
      "add_new_service_menu": "Aggiungi un nuovo menu dei servizi",
      "no_service_menus_in_location": "Inizia creando un nuovo menu dei servizi e aggiungendo i gruppi",
      "no_service_menu_found": "Nessun menu dei servizi disponibile",
      "no_service_menu_found_desc": "La tua ricerca non ha trovato alcun menu dei servizi.",
      "apply": "Applica",
      "troubleshoot_calendar": "Risolvi i problemi del calendario",
      "round_robin_booking": "A rotazione",
      "round_robin_description": "Distribuisce gli appuntamenti tra i membri del team a rotazione.",
      "round_robin_example": "Ad esempio: chiamate di vendita, sessioni di onboarding.",
      "unassigned_booking": "Calendario degli eventi",
      "unassigned_description": "Per programmare eventi fisici senza associazione con un host.",
      "unassigned_example": "Ad esempio: conferenze, seminari pubblici, esposizioni.",
      "event_booking_alert_title": "Importante",
      "event_booking_alert_message": "Questo tipo di calendario presenta differenze fondamentali.",
      "event_booking_learn_more": "Scopri di più",
      "event_booking_tooltip_title": "Cose da sapere:",
      "event_booking_tooltip_content": "• I calendari degli eventi non hanno utenti, quindi gli incontri non possono essere assegnati a un utente.\n• Poiché non c'è nessun utente assegnato, gli strumenti per i link agli incontri dinamici non sono supportati (Zoom, Google Meet, Microsoft Teams). Per utilizzare le riunioni online, copia un link di conferenza statico da un qualsiasi strumento e incollalo nel luogo dell'incontro.\n• Poiché non c'è nessun utente assegnato, gli incontri non sono sincronizzati con il calendario di un utente da Impostazioni calendario → Connessioni. I calendari in conflitto aggiunti lì non vengono presi in considerazione.\n• Gli incontri si sincronizzano solo con il calendario selezionato in Sincronizzazione esterna per questo calendario.\n• Gli eventi vengono recuperati e inviati solo al calendario esterno selezionato.\n• È possibile connettere un solo calendario Google tramite la sincronizzazione esterna.",
      "class_booking": "Prenotazione del corso",
      "class_booking_description": "Un host incontra più partecipanti.",
      "class_booking_example": "Ad esempio: webinar, formazione di gruppo, corsi online.",
      "collective_booking": "Prenotazione di gruppo",
      "collective_booking_description": "Più host incontrano un partecipante.",
      "collective_booking_example": "Ad esempio: interviste di gruppo, revisioni di comitato.",
      "service_booking": "Prenotazione dei servizi",
      "service_booking_description": "Programmazione senza soluzione di continuità per le aziende basate sui servizi.",
      "service_booking_example": "Ad esempio: appuntamenti in una spa, servizi di riparazione, consulenze.",
      "personal_booking": "Prenotazione personale",
      "personal_booking_description": "Programma incontri individuali con un membro specifico del team.",
      "personal_booking_example": "Ad esempio: incontri con i clienti, consulenze private.",
      "personal": "Personale",
      "explore_more_types": "Esplora più tipi",
      "no_calendars_added": "Non ci sono ancora calendari: configuriamone uno!",
      "no_calendars_added_description": "Crea il tuo primo calendario per avviare Programma senza sforzo.",
      "no_groups_added": "Non ci sono ancora gruppi: inizia a organizzare!",
      "no_calendars_yet": "Non ci sono ancora calendari",
      "no_groups_yet": "Non ci sono ancora gruppi",
      "no_calendars_access": "Non è stato ancora creato alcun calendario. Una volta creato, un calendario apparirà qui. Ma non disponi dell'accesso per creare un calendario—per favore, contatta il tuo amministratore.",
      "no_groups_access": "Nessun gruppo è stato ancora configurato. Una volta creato un gruppo, apparirà qui. Tu non disponi dell'Accesso per creare un gruppo—per favore, contatta il tuo Amministratore Se necessario.",
      "no_groups_added_description": "Usa Gruppo per Mantieni i tuoi calendari strutturati. Aggiungi calendari a un gruppo e Condividi un individuo Gruppo Link di programmazione per prenotazione Semplice.",
      "group_success_message": "Il gruppo è stato creato con successo.Ora è possibile aggiungere calendari a questo gruppo.",
      "choose_calendars": "Scegli i calendari",
      "do_it_later": "Lo farò più tardi",
      "add_calendars_to_group": "Aggiungi calendari al gruppo",
      "select_calendars_to_add": "Seleziona tutti i calendari che desideri includere al Gruppo {name}",
      "add_calendars": "Aggiungi calendari",
      "continue": "Continua",
      "conflicting_calendars": "Calendari in conflitto",
      "conflicting_calendars_description": "I calendari Seguente fanno già parte di Altro Gruppo. Tu vuoi spostarli nel tuo Nuovo Gruppo, <b>{name}</b>?",
      "group_associated_with": "Gruppo Attuale",
      "move_calendar_consent": "I Abilita Spostamento questi calendari al Nuovo Gruppo.",
      "calendars_moved_successfully": "ogni calendari Selezionato sono stati spostati con successo in {name}.",
      "new_group": "Nuovo gruppo",
      "back": "Indietro",
      "share_otl": "Condividi la tua Disponibilità ogni dati con un Link univoco che scende dopo una prenotazione, garantendo Gestisci Accesso.",
      "copied_to_clipboard": "Copiato negli appunti",
      "generate_link": "Genera nuovo link",
      "generate_link_error": "Impossibile generare link temporaneo. Riprova",
      "share_schedule_link": " Il Link di programmazione è determinato Tramite lo Slug. Modificando lo Slug, il Link di programmazione si adatta automaticamente alla modifica.",
      "share_permanent_link": "Ideale per Funnel, Sito web Reindirizzamenti, O Pubblicità, il Link permanente rimane costante, inalterato tramite Slug Dinamico.",
      "copy": "Copia",
      "share_embed_code": "Inserisci questo codice in tuo HTML dove vuoi che appaia il tuo Widget {embedType}.",
      "scheduling_link": "Link di programmazione",
      "permanent_link": "Link permanente",
      "one_time_link": "Link monouso",
      "embed_code": "Codice di incorporamento",
      "qr_code": "Codice QR",
      "qr_code_load_error": "Impossibile caricare il codice QR",
      "loading": "Caricamento...",
      "share_group": "Condividi gruppo",
      "edit_group": "Modifica gruppo",
      "more_options": "Altre opzioni",
      "share_calendar": "Condividi calendario",
      "edit_calendar": "Modifica calendario",
      "troubleshoot_calendar_link": "Risolvi i problemi del calendario",
      "calendar_config_success": "Tu hai configurato con successo il tuo calendario personale/di gruppo",
      "close": " Chiudi",
      "added_calendars": "Calendari aggiunti",
      "select_calendars": "Seleziona calendari",
      "settings_confirmation": "A Procedi, per favore, confermi queste Dinamico.",
      "consent_checkbox_title": "Comprendo e accetto queste modifiche.",
      "confirm": "Conferma",
      "create_group_access_disabled": "Non disponi dell'autorizzazione per creare un gruppo. Contatto il tuo amministratore per Accesso.",
      "create_calendar_access_disabled": "Non hai l'autorizzazione per creare un calendario. Contatto il tuo amministratore per Accesso.",
      "create_room_access_disabled": "Non hai l'autorizzazione per gestire le stanze. Contatta il tuo amministratore per ottenere l'accesso.",
      "create_equipment_access_disabled": "Non hai l'autorizzazione per gestire le attrezzature. Contatta il tuo amministratore per ottenere l'accesso.",
      "preview_booking_widget": "Anteprima del widget di prenotazione",
      "share_service_menu": "Condividi menu dei servizi",
      "back_message": "Torna all'elenco dei calendari",
      "service_calendars": "Calendari dei servizi",
      "owned_by": "Di proprietà tramite",
      "owned_by_anyone": "Chiunque",
      "owned_by_me": "Io",
      "all_groups": "Tutti i gruppi",
      "all_calendars": "Tutti i calendari",
      "not_grouped": "Non raggruppato",
      "delete_group_desc": "Sei sicuro che tu di voler eliminare questo gruppo? Questo eliminerà anche tutti i calendari Membri con questo gruppo.",
      "calendar_listing_title": "Elenco calendari",
      "calendar_group_name": "Nome calendario/gruppo",
      "success": "Successo",
      "my_calendar": "il-mio-calendario",
      "service_calendar_description": "Programmazione ottimizzata per le aziende di servizi."
    },
    "preferences": {
      "preferences": "Preferenze",
      "my_preferences": "La mia preferenza",
      "account_preferences": "Preferenze dell'account",
      "user_preferences": "Preferenze utente",
      "set_preferences": "Imposta le tue preferenze per il tuo account.",
      "scheduling_options": "Opzioni di programmazione",
      "meeting_location": "Luogo dell'incontro",
      "zoom": "Zoom",
      "save_preferences": "Salva preferenze",
      "in_app_preferences": "Preferenze nell'app",
      "set_start_day": "Imposta le preferenze come il giorno di inizio per l'app",
      "view_options": "Visualizza opzioni",
      "services": "Servizi",
      "feature_toggle_aria": "Funzione attiva/disattiva",
      "week_starts_on": "La settimana inizia:",
      "sunday": "Domenica",
      "widget_preferences": "Preferenze dei widget",
      "set_widget_language": "Imposta le preferenze come la lingua per il widget",
      "language_and_region": "Lingua e regione",
      "language": "Lingua",
      "english": "Inglese",
      "time_format": "Formato dell'ora",
      "time_format_value": "13:30",
      "monday": "Lunedì",
      "custom_meeting_location": "Luogo di incontro personalizzato",
      "view_appointments_in_1": "Visualizza appuntamenti in",
      "timezone_uses_details_1": "Utilizzeremo questo Fuso orario per la Presentazione degli orari degli Appuntamento in tutta l'App e nelle tue email relative agli Appuntamento, solo per te. Non influirà sulla tua disponibilità o sul modo in cui gli altri prenotano con te.",
      "business_timezones_1": "Fuso orario dell'azienda",
      "business_timezones_tooltip_1": "Messaggio: Scegliendo questa opzione, si garantisce che la tua Preferenza di visualizzazione sia allineata al Fuso orario Impresa selezionato. Se il fuso orario dell'Impresa cambia, il tuo fuso orario di visualizzazione si modificherà automaticamente per corrispondere.",
      "recommended_timezones": "Fusi orari consigliati",
      "all_timezones": "Tutti i fusi orari"
    },
    "availability": {
      "availability": "Disponibilità",
      "my_availability": "La mia disponibilità",
      "my_availability_and_booking_rules": "Programma della disponibilità",
      "my_availability_and_booking_rules_description": "Imposta quando è possibile prenotare gli incontri in base alla disponibilità del personale.",
      "account_availability": "Disponibilità dell'account",
      "timezone": "Fuso orario",
      "working_hours": "Orario di lavoro",
      "set_recurring_hours": "Imposta i tuoi orari di lavoro ricorrenti per gli incontri",
      "select_one": "Selezionane uno",
      "sunday": "Domenica",
      "monday": "Lunedì",
      "tuesday": "Martedì",
      "wednesday": "Mercoledì",
      "thursday": "Giovedì",
      "friday": "Venerdì",
      "saturday": "Sabato",
      "widget_preferences": "Preferenze dei widget",
      "set_widget_language": "Imposta le preferenze come la lingua per il widget",
      "language_and_region": "Lingua e regione",
      "language": "Lingua",
      "english": "Inglese",
      "copy_to_all": "Copia a tutti",
      "save_availability": "Salva disponibilità",
      "add_time": "Aggiungi ora",
      "to": "A",
      "select_time": "Seleziona ora",
      "add_user": "Aggiungi utente",
      "accessRestricted": {
        "header": "Accesso limitato",
        "message": "Non fai parte di questo account. Per ottenere l'accesso, aggiungiti a questo account tramite Impostazioni dell'agenzia > Team > Modifica membro del team, quindi assegna l'account da \"Ruoli e autorizzazioni\".",
        "contact_admin": "Questa pagina è pubblica solo per gli amministratori. Per favore, contatta il tuo amministratore per ricevere assistenza.",
        "button_text": "Vai alle Impostazioni dell'agenzia."
      },
      "schedule": {
        "edit_schedule": "Modifica la programmazione",
        "schedule_name": "Nome programma",
        "schedule_name_required": "Il nome del programma è obbligatorio",
        "timezone": "Fuso orario",
        "timezone_placeholder": "Selezionane una",
        "start_time": "Ora di inizio",
        "end_time": "Ora di fine",
        "add_availability_hour": "Aggiungi ora di disponibilità",
        "remove_availability_hour": "Rimuovi l'ora di disponibilità",
        "unavailable": "Non disponibile",
        "schedule_created": "Programma creato correttamente",
        "schedule_updated": "Programma aggiornato con successo",
        "calendars_selected": "{count} calendario",
        "calendars_selected_multiple": "{count} calendari",
        "select_users_placeholder": "Cerca utenti",
        "edit_default_schedule": "Modifica questo programma",
        "customize_event_type_schedule": "Personalizza il programma solo per questo calendario",
        "multi_user_description": "Aggiorna la disponibilità per <b>{count} utenti selezionati</b> - {calendar}",
        "bulk_edit_warning_banner": "Modifica in blocco attivata. Le modifiche sovrascriveranno i programmi esistenti per tutti gli utenti selezionati.",
        "bulk_edit_slot_applies_to_all": "La fascia oraria selezionata verrà applicata a tutti gli utenti selezionati.",
        "bulk_edit_slot_applies_to_selected": "La fascia oraria selezionata verrà applicata a {count} utente/i selezionato/i.",
        "bulk_edit_applies_to_all": "Le modifiche verranno applicate a tutti i {count} utenti selezionati.",
        "bulk_edit_weekly_hours": "Modifica in blocco ore settimanali",
        "bulk_edit_weekly_hours_title": "Modifica in blocco ore settimanali",
        "bulk_edit_weekly_hours_desc": "Questo sostituirà le ore settimanali per tutti gli utenti elencati qui sotto.",
        "edit_now": "Modifica adesso",
        "bulk_edit": "Modifica in blocco",
        "choose_days_weekly_hours": "Scegli il/i giorno/i per impostare le ore settimanali",
        "assign_to": "Assegna a:",
        "configure_weekly_hours": "Configura le ore settimanali",
        "selected_users": "Utenti selezionati:",
        "bulk_edit_select_users": "Seleziona gli utenti a cui applicare",
        "bulk_edit_select_users_placeholder": "Seleziona membri del team...",
        "bulk_edit_select_at_least_one": "Seleziona almeno un utente.",
        "bulk_edit_editing_for": "Modifica per:",
        "bulk_edit_applies_to": "Si applica a:",
        "bulk_edit_user_count": "{count} utente",
        "bulk_edit_users_count": "{count} utenti",
        "show_less": "Mostra meno",
        "more": "più",
        "confirm_delete": "Conferma eliminazione",
        "confirm": "Conferma",
        "delete_user_date_confirm": "Vuoi davvero eliminare le ore specifiche per data di <b>{userName}</b> il <b>{date}</b>?",
        "delete_date_confirm": "Vuoi davvero eliminare le ore specifiche per data per tutti gli utenti il <b>{date}</b>?",
        "selected_calendar": "calendario selezionato",
        "edit_schedule_alert": "Le modifiche effettuate verranno applicate a",
        "schedule": "Programma",
        "no_availability": "Nessuna disponibilità",
        "date_specific_hours_show_more": "più",
        "date_specific_hours_show_less": "meno",
        "date_specific_hours_recurring_meetings_enabled": "Non è possibile aggiungere ore specifiche per data perché questo programma è collegato a un calendario con incontri ricorrenti abilitati. Per procedere, disabilita gli incontri ricorrenti.",
        "recurring_incompatible_with_date_hours": "Gli incontri ricorrenti non possono essere abilitati perché il programma dell'utente include orari specifici per ogni data, il che è incompatibile.",
        "incompatible_schedule_with_recurring": "{user} programma contiene ore specifiche per data, che sono incompatibili con le riunioni ricorrenti.",
        "incompatible_schedule_with_recurring_calendar": "Il programma contiene ore specifiche per data, che sono incompatibili con le riunioni ricorrenti.",
        "recurring_meetings_enabled_multi_user": "Gli incontri ricorrenti non sono supportati per i calendari con più membri del team o quando un membro del team ha orari specifici per una data aggiunti al proprio programma.",
        "weekdays": "Giorni feriali, {timeRange}",
        "weekdays_hours_vary": "Giorni feriali, orari variabili",
        "weekend": "Fine settimana, {timeRange}",
        "weekend_hours_vary": "Fine settimana, orari variabili",
        "days_hours_vary": "{days}, orari variabili",
        "date_specific_hours_tab_name": "Ore specifiche per data",
        "date_specific_hours": "{count} orari specifici per data",
        "date_specific_hours_1": "1 orario specifico per data",
        "weekly_hours": "Ore settimanali",
        "custom_schedule": "Programma personalizzato",
        "select_schedule": "Seleziona una programmazione",
        "no_schedules_found": "Nessun programma trovato",
        "untitled": "Senza titolo",
        "error_updating_schedules": "Errore durante l'aggiornamento delle pianificazioni",
        "daily": "Ogni giorno",
        "weekly": "Settimanale",
        "monthly": "Mensile",
        "custom": "Personalizzato",
        "this_is_required": "Questo è obbligatorio",
        "search": "Cerca",
        "edit_hours": "Modifica le ore",
        "schedule_name_duplicate": "Esiste già un programma con questo nome",
        "delete_schedule_title": "Vuoi eliminare il programma \"{scheduleName}\"?",
        "delete_schedule_description": "Questa azione non può essere annullata. Vuoi davvero procedere?",
        "delete_schedule_negative_text": "Annulla",
        "delete_schedule_positive_text": "Sì, elimina.",
        "active_on": "Attivo per",
        "weekly_working_hours": "Ore lavorative settimanali",
        "weekly_working_hours_subtext": "Seleziona i giorni e gli orari in cui lavori",
        "copy_availability_hour": "Copia l'ora di disponibilità",
        "mins": "Minuti",
        "hours": "Ore",
        "save_weekly_hours": "Salva ore settimanali",
        "save_date_specific_hours": "Salva ore specifiche per data",
        "update_weekly_hours_for_users": "Aggiorna le ore settimanali per {count} utenti",
        "set_date_specific_hours_for_users": "Imposta ore specifiche per data per {count} utenti",
        "set_date_specific_hours_for_user": "Imposta ore specifiche per data"
      }
    },
    "connections": {
      "connections": "Collegamenti",
      "connect": "collega",
      "conferencing": "Conferenza",
      "my_connections": "I miei collegamenti",
      "account_connections": "Collegamenti dell'account",
      "connection_preferences": "Preferenze di collegamento",
      "manage_calendars_conferencing_channels": "Gestisci calendari e canali di conferenza",
      "main_integration_calendar": "Calendario principale di integrazione",
      "event_integration_calendar": "Gli eventi creati su un calendario di sistema di cui fai parte verranno creati anche su questo calendario integrato",
      "2way_sync": "Sincronizzazione bidirezionale: crea eventi di sistema dagli eventi prenotati nel calendario integrato principale",
      "calendars": "Calendari",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Controlla se ci sono conflitti",
      "choose_accounts_to_connect": "Scegli quali account vuoi collegare",
      "payments": "Pagamenti",
      "stripe": "Stripe",
      "ads": "Annunci",
      "local_service_ads": "Annunci di servizi locali",
      "fire_workflow": "Attiva i trigger del flusso di lavoro per gli eventi prenotati tramite sincronizzazione bidirezionale",
      "connect_google_outlook": "Collega il tuo account Google/Outlook/iCloud per poter scegliere il calendario primario.",
      "execute_automation": "Esegui automazione",
      "save": "Salva",
      "lsa": "Annunci di servizi locali",
      "no_write_access": "Non hai accesso in scrittura a questo calendario",
      "connection_remove_confirmation": "Stai per rimuovere questa integrazione",
      "active": "Attivo",
      "icloud": {
        "title": "Integrazione iCloud",
        "description": "L'autenticazione a due fattori e una password specifica per l'app sono necessarie per collegare l'account.",
        "email": "Indirizzo email iCloud",
        "password": "Password iCloud",
        "connect": "Collega",
        "cancel": "Annulla"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Seleziona un contatto",
    "start_time": "Ora di inizio",
    "unassigned": "Non assegnato",
    "end_time": "Ora di fine",
    "search_by_name_email_phone_or_company": "Cerca per nome, email, telefono o azienda",
    "add_new": "Aggiungi nuovo",
    "pick_from_available_contacts": "Oppure scegli tra i contatti disponibili",
    "book_appointment": "Prenota appuntamento",
    "add_blocked_off_time": "Aggiungi tempo bloccato",
    "recommended_timezones": "Fusi orari consigliati",
    "all_timezones": "Tutti i fusi orari",
    "calendar": "Calendario",
    "repeat": "Ripetizione",
    "date_and_time": "Data e ora",
    "close": "Chiudi",
    "team_member": "Membro del team",
    "recurring_booking": "Prenotazione ricorrente",
    "one_slot_booking": "Prenotazione di una fascia oraria",
    "event_type": "Tipo di evento",
    "occurrences_booked": "le ricorrenze saranno prenotate",
    "repeats": "Ripetizioni",
    "booking_details": "Dettagli della prenotazione",
    "showing_slots_in_this_timezone": "Mostra le fasce orarie in questo fuso orario:",
    "update_contact_tz": "Aggiorna anche il fuso orario del contatto a",
    "date": "Data",
    "slot": "Fascia oraria",
    "calendar_default": "Calendario predefinito",
    "custom": "Personalizzato",
    "meeting_notes": "(es.) Note dell'incontro per il nostro prossimo appuntamento",
    "out_of_office": "(es.) Fuori ufficio per questa settimana!",
    "standard": "Predefinito",
    "appointment_title": "Titolo dell'appuntamento",
    "event_title": "Titolo dell'evento",
    "appt_with_bob": "(es.) Appuntamento con Bob",
    "vacation": "(es.) Vacanza",
    "show_notes": "Mostra note",
    "hide_notes": "Nascondi note",
    "additional_preferences": "Preferenze aggiuntive",
    "meeting_location": "Luogo della riunione",
    "appointment_status": "Stato dell'appuntamento",
    "appt_description": "Descrizione dell'appuntamento",
    "recurring_details": "Dettagli ricorrenti",
    "event_description": "Descrizione dell'evento",
    "in_contact_timezone": "Fuso orario del contatto",
    "vacation_message": "Vai in vacanza? Vuoi prenderti del tempo libero? Blocca del tempo sul tuo calendario per impedire ai clienti di prenotare appuntamenti. Gli appuntamenti esistenti rimarranno comunque nel tuo calendario.",
    "contact": "Contatto",
    "delete": "Elimina",
    "cancel": "Annulla",
    "back": "Indietro",
    "pick_available_contacts": "Oppure scegli tra i contatti disponibili",
    "no_contacts_found": "Nessun contatto trovato",
    "found": "trovato",
    "select_one": "Selezionane uno",
    "tz_tooltip": "Questo è importante solo se utilizzi valori personalizzati, come appointment_start_time appointment_end_time appointment_timezone e così via, nella tua comunicazione in uscita con i tuoi clienti. E ciò che fa è semplicemente convertire i suddetti dati nell'ora locale.",
    "meeting_location_tooltip": "Il luogo dell'incontro sarà impostato come configurato nel calendario.",
    "appt_meeting_location_tooltip": "L'utente può impostare il luogo dell'incontro specifico per l'appuntamento.",
    "gmeet_tooltip": "Assicurati che il rispettivo membro del team abbia un calendario Google impostato come calendario primario.",
    "zoom_tooltip": "Assicurati che il rispettivo membro del team abbia Zoom integrato.",
    "enter_meeting_location": "Inserisci luogo dell'incontro",
    "save_appointment": "Salva appuntamento",
    "save_event": "Salva evento",
    "search_contacts": "Cerca per nome, email, telefono o azienda",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Fuso orario personalizzato",
    "system_timezone": "Fuso orario del sistema",
    "contact_timezone": "Fuso orario del contatto",
    "account_timezone": "Fuso orario dell'account",
    "an_error_occurred": "Si è verificato un errore"
  },
  "popup": {
    "calendar": "Calendario",
    "appointment_owner": "Titolare dell'appuntamento",
    "source": "Fonte",
    "booked_by": "Prenotato da",
    "view_activity_log": "Visualizza il registro delle attività",
    "status": "Stato",
    "cancel_appointment": "Annulla appuntamento",
    "cancel_all": "Annulla tutto",
    "google_event": "Evento Google",
    "outlook_event": "Evento di Outlook",
    "blocked_slot": "Fascia oraria bloccata",
    "appointment": "Appuntamento",
    "confirmed": "Confermato",
    "unconfirmed": "Non confermato",
    "cancelled": "Annullato",
    "showed": "Presentazione",
    "no_show": "Mancata presentazione",
    "invalid": "Non valido",
    "more": "Più",
    "less": "Meno",
    "edit": "Modifica",
    "reschedule_all": "Riprogramma tutto",
    "guests": "Ospite/i",
    "guest_count": "Numero di ospiti"
  },
  "create_calendar": {
    "calendar_name": "Nome del calendario",
    "calendar_logo": "Logo del calendario",
    "select_team_member": "Seleziona membri del team",
    "select_single_team_member": "Seleziona membro del team",
    "eg_outbound_reach": "(es.) Portata in uscita",
    "description": "Descrizione",
    "amount": "Importo",
    "description_placeholder": "Scrivi descrizione",
    "meeting_duration": "Durata dell'incontro",
    "meeting_location": "Luogo dell'incontro",
    "seats_per_class": "Posti per corso",
    "group": "Gruppo",
    "custom_url": "URL personalizzato",
    "meeting_invite_title": "Titolo dell'invito all'incontro",
    "event_color": "Colore dell'evento",
    "availability_type": "Tipo di disponibilità",
    "new_calendar": "Nuovo calendario",
    "add_description": "Aggiungi descrizione",
    "remove_description": "Rimuovi descrizione",
    "booking_availability": "Disponibilità della prenotazione",
    "slug_tooltip": "Personalizza l'URL del widget di prenotazione.",
    "meeting_location_tooltip": "I link agli incontri vengono visualizzati in Eventi del calendario come \"luogo dell'incontro\" e consentono di aggiungere elementi come i link di Zoom per l'evento.",
    "advanced_settings": "Impostazioni avanzate",
    "show_more_schedule": "Mostra altro",
    "show_more_helper_text": "Per personalizzare ulteriormente il tuo orario di lavoro, vai alle impostazioni avanzate.",
    "reschedule_preference": "Preferenza di riprogrammazione",
    "reschedule_preference_subtext": "Se un {contactLabel} riprogramma un appuntamento:",
    "reassign_through_round_robin": "Riassegna tramite assegnazione a rotazione",
    "keep_same_assinged_user": "Mantieni lo stesso titolare dell'appuntamento",
    "new_appointment_preference": "Preferenza per i nuovi appuntamenti",
    "new_appointment_preference_text": "Prenota sempre con l'utente assegnato al {contactLabel}.",
    "new_appointment_preference_subtext": "Prenota i nuovi appuntamenti con l'utente assegnato al {contactLabel}, invece di usare la programmazione a rotazione.",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "service_calendar_name": "Nome del servizio",
    "service_logo": "Logo del servizio",
    "service_select_team_member": "Seleziona un membro del personale",
    "service_duration": "Durata del servizio",
    "appointment_invite_title": "Titolo dell'invito all'appuntamento",
    "payment_placeholder": "Inserisci una descrizione che verrà mostrata all'utente per informarlo del pagamento",
    "deposit_amount": "Importo dell'acconto",
    "collect_deposit_amount": "Accetta pagamento parziale",
    "percentage": "Percentuale",
    "total_amount": "Importo totale",
    "enter_meeting_location": "Inserisci luogo dell'incontro",
    "accept_payments": "Accetta pagamenti",
    "aria": {
      "should_accept_payment": "Dovrebbe accettare il pagamento"
    },
    "calendar_name_tooltip": "Nome del calendario da visualizzare nel widget di prenotazione.",
    "booking_availability_tooltip": "Imposta i giorni e le ore durante i quali è possibile effettuare prenotazioni. Questi sono i tuoi orari lavorativi settimanali predefiniti mostrati agli utenti quando selezionano una fascia oraria.",
    "select_team_member_tooltip": "Seleziona il membro o i membri del team che parteciperanno a questo incontro.",
    "seats_per_class_tooltip": "Imposta il numero massimo di partecipanti autorizzati a prenotare questo corso. Una volta occupati tutti i posti, la fascia oraria non sarà più disponibile per la prenotazione.",
    "meeting_color": "Conferenza Colore",
    "meeting_duration_tooltip": "Questo imposta la durata del tuo incontro, determinandone la durata."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Suggerimento rapido",
      "timezone_change_tip": "I fusi orari possono essere cambiati in qualsiasi momento dalle preferenze del fuso orario",
      "save": "Salva modifiche",
      "close": "Chiudi",
      "meeting_details": "Informazioni di base",
      "availability": "Disponibilità",
      "forms_and_payment": "Moduli e pagamento",
      "notifications_and_additional_options": "Notifiche e opzioni aggiuntive",
      "connections": "Collegamenti",
      "customizations": "Personalizzazioni",
      "create": "Crea",
      "edit": "Modifica",
      "equipments": "Sale e attrezzatura",
      "service_details": "Dettagli del servizio",
      "booking_rules": "Regole di prenotazione",
      "advanced_settings": "Impostazioni avanzate",
      "form_and_confirmation": "Modulo e conferma",
      "payments": "Pagamenti",
      "notifications_and_policies": "Notifiche e politiche",
      "widget_appearance": "Aspetto del widget",
      "saving_changes": "Just a Minute — Salvataggio l'ultima Dinamico...",
      "calendar_id": "ID calendario",
      "saveCalendarSuccess": "Calendario salvato correttamente",
      "external_sync": "Sincronizzazione esterna",
      "external_sync_and_channel": "Sincronizzazione esterna & canali",
      "booking_channels": "Canali di prenotazione",
      "meeting_location": "Luogo dell'incontro",
      "staff_location": "Personale e luogo"
    },
    "meeting_details": {
      "meeting_location": "Luogo dell'incontro",
      "meeting_location_label": "Luogo dell'incontro",
      "enter_meeting_location": "Inserisci luogo dell'incontro",
      "click_to_upload": "Fai clic per caricare",
      "square": "Quadrato",
      "circle": "Cerchio",
      "remove_logo": "Rimuovi logo",
      "meeting_invite_title_tooltip": "Questo è il titolo dell'incontro nel calendario che viene visualizzato nella Vista elenco appuntamenti, nella Vista calendario e nei calendari di terze parti.",
      "event_color_tooltip": "Scegli un colore per questo evento di prenotazione. I colori vengono sincronizzati con gli eventi del calendario Google.",
      "enter_a_name": "Inserisci un nome.",
      "enter_an_event_title": "Inserisci il titolo dell'evento.",
      "high_priority": "Priorità alta",
      "medium_priority": "Priorità media",
      "low_priority": "Priorità bassa",
      "priority": "Priorità",
      "custom": "Personalizzato",
      "zoom_not_added": "L'utente non ha ancora collegato il suo account Zoom.",
      "opt_avail": "Ottimizza per la disponibilità",
      "opt_equal": "Ottimizza per una distribuzione equa",
      "team_members": "Seleziona membri del team",
      "team_members_location": "Seleziona il membro del personale e assegna il luogo dell'incontro",
      "team_member": "Seleziona membro del team",
      "team_member_location": "Seleziona il membro del personale e assegna il luogo dell'incontro",
      "meeting_location_required": "Il luogo dell'incontro è obbligatorio.",
      "meeting_details": "Informazioni di base",
      "meeting_details_description": "Informazioni di base utilizzate per identificare questo calendario.",
      "or_drag_and_drop": "oppure trascina e rilascia",
      "service_details": "Dettagli del servizio",
      "team_member_disabled_recurring_tooltip": "Gli incontri ricorrenti consentono un solo membro del team. Per aggiungere più membri del team, disabilita gli incontri ricorrenti.",
      "team_member_disabled_class_booking_tooltip": "È possibile aggiungere un solo membro del team al calendario delle prenotazioni di un corso.",
      "advanced_settings": "Impostazioni avanzate",
      "enable_contact_assigned_to_setting": "Per abilitare questa impostazione, il modulo deve essere il primo nell'ordine dei widget. Riorganizza l'ordine dei widget dalla scheda Moduli e pagamento.",
      "reschedule_preference_setting_tooltip": "Scegli a chi assegnare l'appuntamento quando un {contactLabel} riprogramma dal widget di prenotazione.",
      "appointment_preference_tooltip": "Scegli se i nuovi appuntamenti devono essere sempre prenotati con l'utente assegnato al {contactLabel}. Se a un {contactLabel} è assegnato un utente, a quell'utente verrà data la preferenza; in caso contrario, si procederà con l'assegnazione a rotazione. Suggerimento: disattiva \"Consenti selezione del personale\" per impedire ai clienti di modificare il membro del personale nel widget di prenotazione.",
      "add_location": "Aggiungi luogo",
      "multiple_locations_neo": "Offri a chi prenota più opzioni di luogo tra cui scegliere. La disponibilità di più luoghi è supportata solo dal widget Neo.",
      "make_owner": "Rendi titolare",
      "only_one_team_member": "Quando si aggiungono più luoghi, è consentito un solo membro del team.",
      "ask_the_booker_error_message": "Chiedi a chi prenota: il luogo esiste già.",
      "enter_location": "Inserisci il valore del luogo",
      "enter_display_label": "Inserisci etichetta di visualizzazione",
      "add_display_label": "Aggiungi etichetta di visualizzazione",
      "multiple_location_support_message": "Offri a chi prenota più opzioni di luogo tra cui scegliere. La disponibilità di più luoghi è supportata solo dal widget Neo.",
      "only_one_team_member_personal_calendar": "Per la prenotazione personale è consentito un solo membro del team. ",
      "ms_teams_not_added": "L'utente non ha ancora collegato il suo account Microsoft Teams.",
      "enable_new_appt_preference": "Abilita la preferenza per il nuovo appuntamento",
      "enable_new_appt_preference_desc": "Attivando &quot;<b>Prenota sempre con l'utente assegnato al {contactLabel}</b>&quot;, il <b>modulo</b> verrà automaticamente impostato come primo passaggio nell'ordine dei widget.",
      "location_exists_toast": "Conferenza Luogo già aggiunta",
      "not_supported_with_multiple_team_members": "Non è supportato con più membri del team",
      "not_supported_personal_calendar": "Non è supportato nel calendario personale",
      "not_supported_class_booking": "Non supportato nel calendario di prenotazione dei corsi",
      "not_supported_collective_booking": "Non è supportato nel calendario collettivo",
      "not_supported_service_booking": "Non supportato nel calendario dei servizi",
      "not_supported_round_robin": "Non supportato nel calendario a rotazione",
      "not_supported_event": "Non supportato nel calendario degli eventi",
      "calendar_logo_tooltip": "Scegli un logo da mostrare nel widget di prenotazione.",
      "calendar_name_tooltip": "Nome del calendario da visualizzare nel widget di prenotazione.",
      "description_tooltip": "Fornisci una descrizione del contenuto del calendario da visualizzare nel widget di prenotazione.",
      "group_tooltip": "Puoi assegnare questo calendario a un gruppo (se è stato creato). Gli utenti che accedono al link del gruppo possono esplorare e prenotare da tutti i calendari di quel gruppo.",
      "custom_url_tooltip": "Personalizza l'URL del widget di prenotazione.",
      "meeting_color_tooltip": "Scegli un colore per questo evento di prenotazione.",
      "add_display_label_tooltip": "Nascondi il luogo effettivo e mostra un'etichetta personalizzata fino a quando la prenotazione dell'incontro non è completata (si applica quando vengono aggiunti più luoghi).",
      "meeting_location_tooltip": "Seleziona un luogo, oppure scegli Personalizzato per aggiungere un indirizzo o un link per l'incontro.",
      "team_members_location_tooltip": "Seleziona il membro del personale che si occuperà di questo incontro e imposta il luogo in cui si terrà.",
      "meeting_distribution": "Distribuzione delle riunioni",
      "meeting_distribution_tooltip": "Scegli come assegnare gli incontri al personale.",
      "opt_avail_tooltip": "Assegna gli incontri al membro del personale disponibile all'orario selezionato, indipendentemente dalle prenotazioni precedenti. Ottimizza l'uso delle fasce orarie disponibili e aumenta i tassi di completamento ottimale delle prenotazioni.",
      "opt_equal_tooltip": "Distribuisci gli incontri in modo uniforme tra tutto il personale tenendo traccia delle prenotazioni precedenti. Questa opzione dà priorità alla distribuzione equa rispetto alla disponibilità.",
      "priority_tooltip": "Configura il livello di preferenza per l'assegnazione degli incontri quando sono disponibili più membri del personale. Per le prenotazioni, i membri del personale con la priorità più alta verranno considerati per primi, seguiti da quelli di media e bassa priorità.",
      "contact_routing_preference": "Preferenza per il routing dei contatti",
      "contact_routing_preference_tooltip": "Definisci come i {contactsLabel} nuovi e di ritorno vengono assegnati ai membri del personale: a rotazione o dal titolare originale.",
      "team_members_location_owner_tooltip": "L'utente principale titolare dell'incontro che fornisce il luogo finale dell'incontro.",
      "owner": "Titolare",
      "upload_from_system": "Carica dal sistema",
      "choose_from_media_storage": "Scegli dall'unità di archiviazione dei contenuti multimediali",
      "only_one_team_member_allowed": "È consentito un solo membro del team.",
      "at_least_two_team_members_required": "Sono richiesti almeno 2 membri del team.",
      "at_least_one_team_member_required": "È richiesto almeno un membro del team.",
      "widget_shape": "Forma del widget:",
      "widget_bookings_path": "/widget/prenotazioni/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "foto-profilo",
      "meeting_location_placeholder": "Luogo dell'incontro",
      "team_member_meeting_location": "Personale e luogo dell'incontro",
      "meeting_location_desc": "Assegna il personale a questo calendario e imposta dove si tengono gli incontri.",
      "event_calendar_meeting_location_desc": "Scegli dove si terrà l'incontro."
    },
    "meeting_location": {
      "ask_the_booker": "Chiedi a chi prenota (chi prenota inserisce il luogo)",
      "ask_the_booker_desc": "Al momento della prenotazione, alla persona che desidera prenotare viene richiesto di inserire un luogo a sua scelta",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "lc_meet": "Sala riunioni",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Telefono",
      "full_address": "Indirizzo completo",
      "custom": "Personalizzato",
      "meeting_location": "Luogo dell'incontro"
    },
    "availability": {
      "my_availability": "La mia disponibilità",
      "calendar_availability": "Disponibilità nel calendario",
      "calendar_availability_desc": "Imposta quando è possibile prenotare gli incontri su questo calendario.",
      "set_availability": "Imposta qui la tua disponibilità per il calendario.",
      "standard": "Standard",
      "custom": "Personalizzata",
      "to": "A",
      "copy_to_all": "Copia a tutti",
      "add_time": "Aggiungi ora",
      "recurring_meeting": "Incontro ricorrente",
      "recurring_info": "Solo un utente per calendario per le prenotazioni ricorrenti.",
      "repeat": "Ripetizione",
      "times_to_repeat": "Numero di ripetizioni",
      "slots_unavailable": "Se le fasce orarie non sono disponibili?",
      "overlap_status": "Stato dell'appuntamento per fasce orarie sovrapposte ",
      "meeting_interval": "Intervallo di incontro",
      "meeting_duration": "Durata dell'incontro",
      "minimum_scheduling": "Preavviso minimo di programmazione",
      "date_range": "Intervallo di date",
      "count_available_days_only": "Conta solo i giorni disponibili",
      "count_available_days_only_tooltip": "Conta solo i giorni in cui questo calendario è disponibile, a partire da dopo il preavviso minimo di programmazione. Ad esempio, se tieni chiuso durante il fine settimana, un intervallo di 2 giorni di venerdì si estenderà per mostrare lunedì e martedì.",
      "maximum_bookings_per_day": "Numero massimo di prenotazioni al giorno",
      "maximum_bookings_per_slot": "Numero massimo di prenotazioni per fascia oraria",
      "maximum_bookings_per_slot_per_user": "Numero massimo di prenotazioni per fascia oraria (per utente)",
      "seats_per_class": "Posti per corso",
      "pre_buffer_time": "Tempo di pre-buffer",
      "post_buffer_time": "Tempo di post-buffer",
      "pre_buffer_tooltip": "Il pre-buffer è un periodo di tempo aggiuntivo che può essere aggiunto prima di un appuntamento per avere più tempo per prepararsi.",
      "post_buffer_tooltip": "Il post-buffer è un periodo di tempo aggiuntivo che può essere aggiunto dopo un appuntamento per avere più tempo per concludere.",
      "buffer_time": "Tempo di buffer",
      "daily": "Quotidiana",
      "weekly": "Settimanale",
      "monthly": "Mensile",
      "skip_booking": "Salta la prenotazione di fasce orarie non disponibili",
      "continue_booking": "Continua a prenotare",
      "book_next_available": "Prenota la prossima fascia oraria disponibile",
      "confirmed": "Confermato",
      "unconfirmed": "Non confermato",
      "enter_valid_hours": "Inserisci orari di apertura validi",
      "enter_valid_avail": "Inserisci una disponibilità personalizzata valida",
      "availability_type_tooltip": "Scegli la disponibilità Standard per le prenotazioni regolari offerte settimanalmente. Scegli Personalizzata per le prenotazioni disponibili solo in date specifiche.",
      "meeting_interval_tooltip": "Imposta la frequenza con cui vengono mostrate le fasce orarie di prenotazione.\nPer un incontro di 30 minuti: \n• Scegli 1 ora per mostrare le fasce orarie all'inizio di ogni ora. \n• Scegli 30 minuti per mostrare le fasce orarie ogni 30 minuti.",
      "date_range_tooltip": "Gli eventi possono essere programmati nei prossimi n giorni.",
      "maximum_bookings_per_day_tooltip": "Numero massimo di incontri al giorno consentiti per questo calendario.",
      "maximum_bookings_per_slot_tooltip": "Limita il numero di incontri a cui un utente può partecipare nella stessa fascia oraria. Se si raggiunge il limite, la prenotazione viene assegnata all'utente successivo nella coda di assegnazione a rotazione, oppure la fascia oraria diventa non disponibile.",
      "add_days": "Aggiungi giorni",
      "month_on_day": "Mensile il giorno",
      "month_on_last_day": "Mensile l'ultimo giorno",
      "day": "Giorno",
      "week": "Settimana",
      "month": "Mese",
      "mins": "Minuti",
      "hours": "Ore",
      "days": "Giorni",
      "weeks": "Settimane",
      "months": "Mesi",
      "meeting_interval_error": "L'intervallo delle riunioni deve essere compreso tra 5 minuti e 12 ore.",
      "meeting_duration_error": "La durata della riunione deve essere compresa tra 1 minuto e 12 ore.",
      "buffer_time_error": "Il tempo di buffer deve essere inferiore a 12 ore.",
      "appointment_interval": "Intervallo di appuntamento",
      "appointment_duration": "Durata dell'appuntamento",
      "maximum_appointments_per_day": "Numero massimo di appuntamenti al giorno",
      "subTitle": "Scegli la data per fissare degli orari specifici.",
      "heading_1": "Ore settimanali disponibili",
      "scheduling_availability_heading": "Disponibilità per la prenotazione",
      "scheduling_availability_tooltip": "Usa un programma di disponibilità esistente oppure creane uno personalizzato per questo calendario.",
      "tooltip_1": "Configura il tuo programma di disponibilità settimanale. Questi sono i tuoi orari standard che verranno applicati con costanza su base settimanale.",
      "heading_2": "Quando sei disponibile?",
      "unavailable_label": "Non disponibile",
      "tooltip_2": "Adatta il tuo programma a date specifiche. Sostituisci il normale orario settimanale contrassegnando la disponibilità o l'indisponibilità per le date selezionate.",
      "date_specific_level": "Aggiungi ore specifiche per data",
      "specific_hours_button": "Ore specifiche per data",
      "specific_hours_description": "Configura la disponibilità personalizzata per date specifiche che differiscono dal tuo programma settimanale.",
      "overlap_error": "Le fasce orarie non possono sovrapporsi",
      "apply": "Applica",
      "copy_times_to": "Copia orari in",
      "no_date_specific_heading": "Non è stato aggiunto nessun orario specifico per data.",
      "no_date_specific_description": "Puoi aggiungere/rimuovere date e orari specifici alla tua disponibilità.",
      "recurring_disabled_conditions_tooltip": "Gli incontri Ricorrente sono Disabilitato. Per trigger , assicurati che il calendario abbia un solo Gruppo Membri e non abbia aggiunto il pagamento O incompleto o una data specifica.",
      "date_specific_hours_disabled_conditions_tooltip": "Per includere un'ora specifica per una data, assicurati che gli incontri ricorrenti siano disattivati.",
      "recurring_disable_event_calendar_conditions": "Gli incontri Ricorrente sono Disabilitato. Per trigger , assicurati che non siano stati aggiunti pagamenti O incompleti specifici per una data.",
      "service_duration": "Durata del servizio",
      "service_interval": "Intervallo di servizio",
      "service_interval_tooltip": "L'intervallo di incontro stabilisce la frequenza con cui le fasce orarie di prenotazione vengono visualizzate nel calendario. Ad esempio, per un evento di 30 minuti, un intervallo di 1 ora significa che le fasce orarie vengono visualizzate ogni ora. Un intervallo di 30 minuti implica che le fasce orarie appaiono ogni 30 minuti.",
      "service_duration_tooltip": "In questo modo si stabilisce la durata dell'appuntamento, determinando quando durerà.",
      "minimum_scheduling_tooltip": "Imposta il tempo minimo necessario per prenotare un appuntamento tramite il widget del calendario. Ad esempio, se impostato su 4 ore, gli appuntamenti non possono essere prenotati entro 4 ore dall'ora di inizio; le prenotazioni devono essere effettuate con almeno 4 ore di anticipo.",
      "look_busy_title": "Molto da fare",
      "look_busy_helper_text": "Nascondi una percentuale delle tue fasce orarie disponibili per gli appuntamenti sul widget di prenotazione per far finta di avere molto da fare e non avere tanto tempo.",
      "look_busy_percentage_description": "Nascondi una percentuale (x%) del numero di fasce orarie disponibili.",
      "maximum_bookings_per_slot_tooltip_personal": "Numero massimo di incontri consentiti in una singola fascia oraria.",
      "enable_recurring_title": "Abilita incontro ricorrente",
      "enable_recurring_desc": "L'attivazione degli <b>incontri ricorrenti</b> disabiliterà automaticamente le seguenti impostazioni, in quanto non possono coesistere:",
      "date_specific_hours": "Tutte le <b>ore specifiche per data</b> verranno rimosse.",
      "multiple_team_members": "Se ci sono <b>più membri del team</b>, verranno rimossi; in questo calendario può rimanere un solo membro del team.",
      "partial_payments": "<b>I Pagamenti incompleti</b> saranno disabilitati e l'importo Pieno verrà raccolto.",
      "select_team_member_to_keep": "Seleziona a Gruppo Membri su Mantieni in questo calendario:",
      "select_team_member": "Seleziona membro del team",
      "partial_payments_disabled": "Dato che i pagamenti parziali saranno disabilitati, come vorresti riscuotere l'intero importo per gli appuntamenti ricorrenti?",
      "enable_date_specific_hours": "Abilita delle ore specifiche per data",
      "enable_date_specific_hours_desc": "L'attivazione delle <b>ore specifiche per data</b> disabiliterà automaticamente le seguenti impostazioni, in quanto non possono coesistere:",
      "recurring_meetings_disabled": "<b>Gli incontri ricorrenti saranno disattivati</b>, i {contactsLabel} potranno prenotare solo appuntamenti singoli in base alle date disponibili che hai impostato.",
      "payment_preference": "Preferenza di pagamento:",
      "team_members_in_this_calendar": "Membri del team in questo calendario",
      "other_team_members": "Altri membri del team (non aggiunti a questo calendario)",
      "select_team_member_tooltip": "Seleziona il membro o i membri del team che parteciperanno a questo incontro.",
      "meeting_duration_tooltip": "Questo imposta la durata del tuo incontro, determinandone la durata.",
      "add_another_duration": "Aggiungi un'altra durata",
      "set_as_default": "Imposta come predefinito",
      "default_duration": "Predefinito",
      "max_duration_options_reached": "È consentito un massimo di 3 opzioni di durata",
      "duplicate_duration_error": "I valori della durata devono essere univoci",
      "empty_duration_error": "La durata dell'incontro è obbligatoria.",
      "multi_duration_tooltip": "Offri diverse opzioni di durata (ad esempio: 15, 30 o 60 minuti). I clienti possono scegliere la durata che preferiscono al momento della prenotazione.",
      "date_specific_hours_tooltip": "Modifica il tuo programma per alcune date specifiche. Modifica il normale orario settimanale contrassegnando la disponibilità o la non disponibilità per le date selezionate.",
      "recurring_meeting_tooltip": "Consenti la ripetizione degli incontri per più volte in un arco di tempo.",
      "repeat_frequency_tooltip": "Seleziona la frequenza di questo evento ricorrente.",
      "time_to_repeat_tooltip": "Configura il numero totale di ricorrenze.",
      "slots_unavailable_tooltip": "Scegli cosa fare se una o più fasce orarie di una prenotazione ricorrente sono già prenotate.",
      "skip_booking_tooltip": "Verranno prenotate solo le fasce orarie disponibili. Eventuali date non disponibili della serie ricorrente verranno saltate.",
      "force_book": "Force Book",
      "force_booking_tooltip": "Verranno prenotate tutte le fasce orarie, anche in presenza di conflitti. Da usare con cautela per evitare le doppie prenotazioni.",
      "book_next_available_tooltip": "Se una fascia oraria selezionata non è disponibile, prenota la successiva fascia oraria disponibile nello stesso programma ricorrente (ad esempio, il lunedì successivo, se la ricorrenza è settimanale).",
      "slot_interval_tooltip": "Imposta l'intervallo tra gli orari di inizio delle fasce orarie consecutive disponibili. Ad esempio, se la durata dell'incontro è di 30 minuti e imposti l'intervallo su 60 minuti, un utente può prenotare alle 9:00, poi alle 10:00 e così via, anche se ogni incontro dura solo 30 minuti.",
      "minimum_scheduling_notice_tooltip": "Richiedi agli utenti di prenotare gli incontri con almeno questo tempo di preavviso.",
      "date_range_preferences_tooltip": "Determina per quanto tempo nel futuro si possono effettuare prenotazioni a partire dalla data odierna.",
      "maximum_bookings_per_slot_preferences_tooltip": "Limita il numero di incontri che possono essere programmati per la stessa fascia oraria.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Limita il numero di incontri che possono essere programmati per la stessa fascia oraria (per utente).",
      "pre_buffer_time_tooltip": "Tempo da bloccare prima di ogni incontro, in modo da avere più tempo per prepararsi.",
      "post_buffer_time_tooltip": "Tempo da bloccare dopo ogni incontro, in modo da avere più tempo per concludere.",
      "seats_per_class_tooltip": "Imposta il numero massimo di partecipanti autorizzati a prenotare questo corso. Una volta occupati tutti i posti, la fascia oraria non sarà più disponibile per la prenotazione.",
      "maximum_bookings_per_slot_per_user_tooltip": "Limita il numero di incontri che possono essere programmati per la stessa fascia oraria (per utente).",
      "repeat_frequency": "Frequenza di ripetizione",
      "slot_interval": "Intervallo tra le fasce orarie",
      "skip_booking_helper_text": "Verranno prenotate solo le fasce orarie disponibili. Eventuali date non disponibili della serie ricorrente verranno saltate.",
      "force_book_helper_text": "Verranno prenotate tutte le fasce orarie, anche in presenza di conflitti. Da usare con cautela per evitare le doppie prenotazioni.",
      "book_next_available_helper_text": "Se a selezionato Fascia oraria non è disponibile, Prenota il Successivo disponibile Fascia oraria Attivo lo stesso Ricorrente programma (es. Successivo Lunedì Se Settimanale).",
      "bulk_edit": "Modifica in blocco",
      "select_users": "Seleziona utenti",
      "select_all": "Seleziona tutto",
      "times_to_repeat_tooltip": "Configura il numero totale di ricorrenze.",
      "custom_recurrence": "Ricorrenza personalizzata",
      "repeats_every": "Si ripete ogni",
      "availability_schedule": "Programma della disponibilità",
      "availability_schedule_desc": "Imposta quando è possibile prenotare gli incontri in base alla disponibilità del personale.",
      "no_users_added": "Non è stato aggiunto nessun membro del personale!",
      "no_users_added_description": "Aggiungi il personale per verificarne la disponibilità",
      "add_users": "Aggiungi membri del personale",
      "minimum_scheduling_notice_error": "Inserisci ≤ 1440 min.",
      "please_select_date": "Seleziona una data per continuare"
    },
    "forms_payment": {
      "forms": "Moduli e ospiti",
      "forms_sub": "Configura le preferenze per la pagina finale visualizzata dopo una prenotazione andata a buon fine.",
      "select_form": "Seleziona modulo",
      "enable_same_user_assignment": "Assegna i contatti ai rispettivi membri del team nel calendario ogni volta che si completa la prenotazione di un appuntamento.",
      "sticky_contacts_label": "{contactsLabel} fisso",
      "sticky_contacts": "Precompila i campi",
      "confirmation_page": "Pagina di conferma",
      "default": "Predefinito",
      "thank_you_message": "Messaggio di ringraziamento",
      "redirect_url": "URL di reindirizzamento",
      "use_custom_form_rules": "Usa le impostazioni del modulo",
      "custom_form_confirmation_alert": "Questo calendario utilizza un modulo personalizzato. Qualsiasi regola condizionale configurata per mostrare o nascondere campi, o per squalificare i lead, verrà sempre eseguita prima della prenotazione.",
      "default_message_tooltip": "Visualizza il messaggio di conferma configurato dopo che l'appuntamento è stato prenotato.",
      "redirect_url_tooltip": "Reindirizza il cliente alla pagina configurata dopo che l'appuntamento è stato prenotato.",
      "use_custom_form_rules_tooltip": "Utilizza il reindirizzamento o il messaggio personalizzato definito nel modulo personalizzato. Se non si applica alcuna regola, verrà mostrato il messaggio di conferma del calendario.",
      "thank_you": "Messaggio di ringraziamento",
      "enter_url": "Inserisci URL",
      "enter_thank_you_message": "Inserisci il messaggio di ringraziamento.",
      "amount_tab_hidden_label": "Segnaposto della scheda Importo",
      "percentage_tab_hidden_label": "Segnaposto della scheda Percentuale",
      "pixel_id": "Meta pixel Id (opzionale)",
      "auto_confirm": "Conferma automatica dei nuovi incontri del calendario",
      "configure_payment": "Configura opzioni di pagamento",
      "accept_payments": "Accetta pagamenti",
      "test": "Test",
      "live": "Live",
      "enable_guests": "Aggiungi ospiti",
      "add_guest_tooltip": "L'opzione di aggiunta di ospiti consente al partecipante di aggiungere più partecipanti allo stesso appuntamento.",
      "add_guest_custom_form_tooltip": "Se abiliti questa opzione, una volta confermato l'appuntamento, gli ospiti riceveranno un'email generata dal sistema con un link al modulo personalizzato. Per evitare l'invio di email duplicate, controlla che non sia già stata configurata un'email di conferma separata per gli ospiti. (Puoi verificalo dalla scheda Notifiche > Notifica di conferma)",
      "add_guest_same_form_check": "Invia lo stesso modulo a tutti gli ospiti per raccogliere informazioni via email.",
      "payment_tooltip": "Il pagamento sarà considerato solo per il partecipante principale e non per gli ospiti.",
      "default_form": "Predefinito (nome, cognome, email, telefono, note)",
      "select_form_tooltip": "Se desideri raccogliere più informazioni rispetto ai campi standard Nome, Cognome, Email e Telefono da chi prenota su questo calendario, crea un modulo personalizzato in Siti > Moduli > Builder, quindi seleziona il modulo dall'elenco a discesa qui sotto.",
      "confirmation_page_tooltip": "Una volta che qualcuno effettua una prenotazione, puoi scegliere di mostrargli un messaggio personalizzato sulla stessa pagina (predefinito) o reindirizzarlo a una pagina a tua scelta (reindirizzamento).",
      "add_guest_collect_email": "Nome ed email",
      "add_guest_collect_detail": "Raccogli i dettagli dell'ospite",
      "add_guest_count_only": "Solo numero",
      "guest_collection_mode_label": "Dettagli degli ospiti da raccogliere",
      "guest_collection_mode_email": "Nome ed email",
      "guest_collection_mode_phone": "Nome e telefono",
      "guest_collection_mode_email_phone": "Nome, email e telefono",
      "custom_email_notification": "Invia agli ospiti un modulo personalizzato.",
      "consent_label": "Casella di controllo del consenso",
      "consent_input_placeholder": "Aggiungi testo per l'acquisizione del consenso",
      "same_user_assignment_tooltip": "Per abilitare questa impostazione, il modulo deve essere il primo sul widget. Per attivare questa impostazione, riorganizza il widget in modo da posizionare prima il modulo.",
      "consent_tooltip": "Chiedi ai contatti di fornire il consenso quando prenotano un incontro.",
      "stripe_error": "Fino a due decimali (esempio: 25,99)",
      "auto_confirm_service": "Conferma automatica dei nuovi appuntamenti",
      "service_form_message": "Se un contatto prenota più servizi, visualizza solo il modulo predefinito nel menu dei servizi.",
      "deposit_amount_error": "L'importo del deposito deve essere inferiore all'importo totale.",
      "deposit_percentage_error": "La percentuale del deposito deve essere inferiore al 100%.",
      "partial_payment_tooltip": "Abilita i pagamenti parziali per riscuotere l'importo del deposito dai clienti durante il processo di prenotazione dell'appuntamento.",
      "partial_payment_enable_error": "L'importo totale inserito deve essere maggiore di 0 per consentire i pagamenti parziali.",
      "payment_disable_text_integration": "Integra un fornitore di pagamento in Pagamenti > Integrazioni per iniziare ad accettare pagamenti",
      "payment_disable_text_recurring": "L'opzione Accetta pagamento non è disponibile per gli incontri ricorrenti. Disattiva gli incontri ricorrenti per abilitare i pagamenti.",
      "date_and_time_selector": "Selettore di data e ora",
      "form_selector": "Modulo",
      "order_step": "Passaggio",
      "widget_order_label": "Ordine dei widget",
      "widget_order_tool_tip": "Riorganizza l'ordine del \"Selettore di data e ora\" e del \"Modulo\" nel widget del calendario. Puoi semplicemente trascinare e riordinare gli elementi in base alle tue preferenze.",
      "widget_re_order_tooltip": "Il riordino è disponibile solo con lo stile widget Neo. Passa a Neo per abilitare il riordino.",
      "widget_re_order_disabled_tooltip": "Per riorganizzare l'ordine dei widget, disabilita \"Preferenza per nuovo appuntamento (Prenota sempre con l'utente assegnato al {contactLabel})\" dalla sezione Dettagli dell'incontro > Membri del team > Impostazioni avanzate.",
      "payment_description_error": "È stato raggiunto il limite massimo di 1000 caratteri.",
      "widget_multiple_location_disabled_tooltip": "Il widget Classico non supporta più luoghi di incontro. Per utilizzare il widget Classico, rimuovi gli eventuali luoghi aggiuntivi.",
      "recurring_payment_label": "Pagamento degli appuntamenti ricorrenti",
      "enable_payments_for_guests": "Abilita i pagamenti per gli ospiti",
      "guest_payment_description": "Poiché Tu've Abilitato l'opzione \"Aggiungi Ospiti\", Tu può anche selezionare a costo per Ospite Quando di booking.",
      "charge_per_attendee": "Costo per partecipante",
      "charge_per_attendee_description": "Moltiplica l'importo totale tramite il numero di partecipanti (inclusi gli ospiti) Quando riscuote il pagamento durante la prenotazione.",
      "click_confirm_description": "Fai clic su Salva per applicare queste modifiche.",
      "multiply_amount_guests": "Raccogli il pagamento per ogni partecipante",
      "multiply_amount_guests_description": "Quando si abilita questa opzione, l'importo da riscuotere durante la prenotazione viene moltiplicato per il numero totale di partecipanti, compresi gli ospiti.",
      "first_appointment_only": "costo solo per il primo Appuntamento",
      "all_appointments": "costo per ogni Appuntamento in anticipo",
      "no_payment_provider_connected": "Nessun fornitore di servizi di pagamento collegato.",
      "no_default_payment_provider": "Nessun Provider di pagamento collegato",
      "provider_not_supported": "Il Provider di pagamento predefinito non è supportato",
      "manage_payment_provider": "Gestisci i fornitori di servizi di pagamento",
      "supported_providers": "Fornitori supportati:",
      "paypal_razorpay_helper_text": "I pagamenti verranno elaborati esclusivamente tramite Razorpay, poiché PayPal non è supportato con i fornitori personalizzati.",
      "rearrange_widget_order": "Riorganizza l'ordine dei widget",
      "change_form_order": "Dinamico the Modulo al secondo Passaggio in Widget Ordina Disabilita il Seguente Impostazione:",
      "change_form_order_desc": "La <b>preferenza per i nuovi appuntamenti (Prenota sempre con l'utente assegnato al {contactLabel})</b> verrà disattivata. Ciò significa che gli appuntamenti possono essere prenotati con qualsiasi membro del team disponibile, anziché essere riservati all'utente assegnato al {contactLabel}.",
      "enable_mandatory_guest": "Crea aggiungendo almeno un Ospite Obbligatorio. L'Ospite Campi sarà pre-aperto e deve essere riempito Prima prenotazione.",
      "enable_mandatory_guest_count": "Effettua il conteggio obbligatorio degli ospiti nel widget di prenotazione.",
      "require_guest_for_booking": "Richiedi ospiti per la prenotazione",
      "sticky_contacts_tooltip": "Compila automaticamente i campi per {contactsLabel} noti.",
      "auto_confirm_tooltip": "Segna automaticamente i nuovi incontri come confermati senza la necessità dell'approvazione manuale. Disattiva questa opzione se desideri esaminare e confermare manualmente ogni prenotazione prima che venga programmata.",
      "confirm_tooltip": "Quando qualcuno effettua una prenotazione, puoi scegliere di mostrargli un messaggio personalizzato sulla stessa pagina (predefinito) o reindirizzarlo a una pagina a tua scelta (URL di reindirizzamento).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Abilita la riscossione dei pagamenti durante le prenotazioni.",
      "total_amount_tooltip": "Imposta il costo totale dell'incontro.",
      "deposit_amount_tooltip": "Importo da riscuotere come acconto al momento della prenotazione.",
      "multiply_amount_guests_all_guests": "Raccogli il pagamento per tutti i partecipanti, inclusi gli ospiti",
      "multiply_amount_guests_all_guests_tooltip": "Quando si abilita questa opzione, l'importo da riscuotere durante la prenotazione viene moltiplicato per il numero totale di partecipanti, compresi gli ospiti.",
      "payment_description": "Descrizione del pagamento",
      "payment_description_desc": "Visualizzato da chi prenota, mentre inserisce i dati di pagamento.",
      "payment_description_tooltip": "Puoi includere eventuali informazioni utili sul pagamento (facoltativo).",
      "test_mode_warning": "Modalità test Dinamico – non verrà elaborata alcuna vera Vendita.",
      "pixel_id_tooltip": "Invia a Meta l'attività del widget di prenotazione, come visualizzazioni, clic e invii, utilizzando il tuo Pixel ID.",
      "forms_description": "Imposta le tue preferenze e impostazioni per la raccolta delle informazioni sui clienti durante le prenotazioni.",
      "payment_mode": "Modalità di pagamento",
      "payment_mode_tooltip": "Alterna tra Modalità test e modalità Live per i pagamenti. in Modalità test non viene effettuata una vera e propria fatturazione: usala per simulare la prenotazione e il pagamento Flusso di lavoro. Passa alla modalità Live per accettare pagamenti effettivi Da Clienti.",
      "enable_coupon": "Abilita codici coupon",
      "enable_coupon_tooltip": "Consenti ai clienti di applicare codici coupon durante la prenotazione. Per assicurarti che funzionino, crea prima dei coupon validi in Pagamenti > Codici coupon.",
      "payment_collection": "Riscossione dei pagamenti",
      "payment_collection_tooltip": "Scegli se riscuotere il pagamento del cliente al momento della prenotazione o se salvare la sua carta nel sistema senza alcun addebito.",
      "charge_upfront": "Riscuoti il pagamento in anticipo",
      "save_card_on_file": "Salva la carta nel sistema",
      "save_card_on_file_desc": "Memorizza in modo sicuro la carta del cliente nel corso della prenotazione. Al momento della prenotazione, non viene effettuato alcun addebito.",
      "guests": "Ospiti"
    },
    "notifications": {
      "third_party_cal": "Impostazioni del calendario di terze parti",
      "third_party_cal_desc": "Imposta le preferenze per i calendari di terze parti.",
      "additional_settings": "Impostazioni aggiuntive",
      "additional_settings_desc": "Configura delle impostazioni aggiuntive per il tuo calendario.",
      "notifications": "Notifiche",
      "notifications_sub": "Configura come inviare le notifiche di prenotazione via email, SMS, WhatsApp, chiamate vocali e avvisi in app.",
      "edit": "Modifica",
      "created_on": "Creato il",
      "updated_on": "Aggiornato il",
      "delivered": "Consegnato",
      "not_available": "N/A",
      "select_notification_type": "Seleziona il tipo di notifica.",
      "notification_person": "Chi dovrebbe ricevere questa notifica?",
      "contact": "{contactLabel}",
      "guest": "Ospite",
      "assigned_user": "Utente assegnato",
      "emails": "Email",
      "alert_email_address": "Indirizzo email di avviso",
      "ack_email": "Email di conferma",
      "send_google_invites": "Consenti a Google Calendar di inviare email di invito o di aggiornamento ai partecipanti.",
      "assign_user_to_contact_desc": "Se abilitato, l'utente assegnato a {contactLabel} corrisponderà al titolare dell'appuntamento con la modifica più recente, che si tratti di una prenotazione, di una riprogrammazione o di una riassegnazione.",
      "send_google_outlook_invites": "Consenti al calendario di Google/Outlook/iCloud di inviare email di invito e aggiornamento ai partecipanti.",
      "assign_user_to_contact": "Assegna i {contactsLabel} ai rispettivi membri del team nel calendario ogni volta che si completa la prenotazione di un appuntamento.",
      "skip_assigning_user_to_contact": "Salta l'assegnazione del {contactLabel} se il {contactLabel} ha già un utente assegnato.",
      "skip_assigning_user_to_contact_desc": "Quando abilitato, l'utente assegnato a {contactLabel} rimarrà invariato, anche se il titolare dell'appuntamento è diverso.",
      "assigned_staff": "Personale assegnato",
      "additional_emails": "Email aggiuntive",
      "assign_user_to_staff": "Assegna sempre il contatto al titolare dell'appuntamento.",
      "allow_cancellation": " Consenti l'annullamento dell'incontro",
      "allow_reschedule": "Consenti la riprogrammazione dell'incontro",
      "allow_cancellation_tooltip": "Se l'opzione è abilitata, un link di annullamento verrà aggiunto alla sezione delle note aggiuntive e incluso nell'invito del calendario. Questo link scadrà come configurato prima dell'ora di inizio dell'incontro, impedendo al prenotante di annullare l'incontro.",
      "allow_reschedule_tooltip": " Se l'opzione è abilitata, un link di riprogrammazione verrà aggiunto alla sezione delle note aggiuntive e incluso nell'invito del calendario. Questo link scadrà come configurato prima dell'ora di inizio dell'incontro, impedendo al prenotante di riprogrammare l'incontro.",
      "cancellation_link_expiry": "Il link di annullamento scadrà",
      "reschedule_link_expiry": "Il link di riprogrammazione scadrà",
      "before_meeting": "prima dell'incontro",
      "cancellation_and_reschedule_policy": "Condizioni di annullamento e riprogrammazione:",
      "meeting_invite_notes": "Note dell'invito all'incontro",
      "meeting_invite_notes_tooltip": "Aggiungi delle note che saranno visualizzate nell'invito del calendario inviato ai clienti. Queste note si sincronizzeranno con i calendari di terze parti nella descrizione dell'incontro."
    },
    "connections": {
      "connections_heading": "Sincronizzazione calendario esterno",
      "booking_channels_heading": "Canali di prenotazione",
      "booking_channels_description": "Imposta il modo in cui questo calendario riceve le prenotazioni da piattaforme esterne.",
      "connections_sub": "Sincronizza gli incontri con i calendari esterni e decidi come vengono gestiti gli eventi.",
      "link_to_calendar": "Link al calendario",
      "sync_option": "Opzione di sincronizzazione",
      "execute_automation": "Esegui automazione",
      "fire_workflow": "Attiva i trigger del flusso di lavoro per gli eventi prenotati tramite sincronizzazione bidirezionale.",
      "reserve_with_google": "Prenota con Google [Obsoleto]",
      "reserve_with_google_setup": "Visualizza le istruzioni di configurazione",
      "reserve_with_google_configure": "Configura",
      "change": "Modifica",
      "rwg_deprecation_notice": "Google ha disattivato <b>Prenota con Google (annunci di Servizi locali)</b>. Le nuove connessioni o le modifiche alle connessioni esistenti non sono più supportate. Per continuare a ricevere prenotazioni da Google, utilizza <b>Google Organic Booking</b>.",
      "rwg_category": "Categoria",
      "rwg_service_type": "Servizio",
      "connect_lsa": "Collegati al tuo account di annunci di Servizi locali.",
      "reserve_error": "Attualmente Prenota con Google è supportato solo per le nicchie aziendali \"Servizi per la casa\", \"Beni immobili\", \"Servizi legali\" (fornitori di servizi locali) negli Stati Uniti.",
      "one_way": "Unidirezionale",
      "two_way": "Bidirezionale",
      "smart": "Intelligente",
      "confirm_remove": "Vuoi davvero rimuovere il calendario Google?",
      "read_only_access": "Non hai accesso in scrittura a questo calendario. Seleziona un calendario diverso.",
      "reserve_with_google_desc": "Questo servizio di calendario sarà elencato in Prenota con Google solo quando l'integrazione sarà riuscita.",
      "check_integration": "Controlla lo stato dell'integrazione",
      "setup_external": "Configura calendario esterno",
      "reserve_price_decimal_error": "Il prezzo con valori decimali non è supportato.",
      "reserve_price_max_error": "Prezzo supportato inferiore a 1000.",
      "link_to_calendar_tooltip": "Seleziona il calendario esterno con cui sincronizzare gli incontri. I calendari di Google collegati nelle Impostazioni del calendario → Connessioni sono tra le scelte disponibili.",
      "one_way_sync": "Unidirezionale",
      "default_one_way": "Sincronizzazione predefinita (sincronizzazione unidirezionale)",
      "one_way_sync_desc": "Gli eventi del calendario collegato vengono sincronizzati come slot riservati e non viene creato alcun contatto per gli ospiti.",
      "two_way_sync": "Sincronizzazione bidirezionale",
      "two_way_sync_desc": "I contatti vengono creati per gli ospiti trovati negli eventi del calendario collegati e questi eventi vengono trasformati in appuntamenti di sistema.",
      "smart_sync": "Sincronizzazione intelligente",
      "smart_sync_desc": "Gli eventi del calendario collegato vengono sincronizzati come appuntamenti per i contatti esistenti. Se non esiste alcun contatto, vengono sincronizzati come slot bloccati senza creare un nuovo contatto.",
      "sync_option_tooltip": "Scegli come vengono gestiti gli eventi dal calendario esterno:\n• Gestione unidirezionale: blocca del tempo su questo calendario senza creare {contactsLabel}\n• Gestione bidirezionale: crea incontri e {contactsLabel} dagli eventi del calendario esterno\n• Gestione intelligente: crea incontri solo per i {contactsLabel} esistenti e blocca il tempo per gli altri.",
      "default_sync": "Predefinito",
      "default_sync_desc": "Sincronizza gli eventi del tuo calendario esterno con questo calendario.",
      "advanced_sync": "Avanzato",
      "advanced_sync_desc": "Sincronizza gli eventi del tuo calendario esterno con questo calendario e crea contatti e appuntamenti nel sistema.",
      "assign_contact_to": "Assegna contatto a",
      "select_calendar": "Seleziona calendario",
      "sync_preferences": "Preferenze di sincronizzazione",
      "sync_preferences_desc": "Come desideri sincronizzare gli eventi del calendario collegati?",
      "recommended": "Consigliato",
      "execute_automation_desc": "Esegui l'automazione quando viene creato un incontro in questo calendario.",
      "save": "Salva modifiche",
      "cancel": "Annulla",
      "reserve_with_google_title": "Prenota con Google",
      "current_connection": "Connessione attualmente attiva:",
      "category": "Categoria",
      "service": "Tipo di servizio",
      "price": "Prezzo preventivato",
      "currency": "Valuta",
      "client_portal_booking": "Prenotazione tramite il portale clienti",
      "client_portal_booking_description": "Consenti a questo calendario di comparire nell'elenco delle prenotazioni del portale clienti",
      "client_portal_url": "URL del portale clienti"
    },
    "booking_rules": {
      "booking_rules": "Regole di prenotazione",
      "booking_rules_description": "Controlla come e quando gli incontri possono essere prenotati."
    },
    "payments": {
      "payments": "Pagamenti",
      "payments_description": " Abilita e gestisci pagamenti, regole e modelli di addebito."
    },
    "extras": {
      "extras": "Personalizzazioni",
      "extras_sub": "Imposta lo stile del widget e altre preferenze.",
      "calendar_widget_style": "Stile del widget del calendario",
      "neo": "Nuovo",
      "classic": "Classico",
      "insert_custom_code": "Inserisci codice personalizzato",
      "show_seats_per_slot": "Mostra posti per fascia oraria",
      "allow_reschedule_meeting": "Consenti riprogrammazione dell'incontro",
      "allow_cancelling_meeting": "Consenti annullamento dell'incontro",
      "additional_notes": "Note aggiuntive",
      "cancellation_and_reschedule": "Annullamento e riprogrammazione:",
      "allow_staff": "Consenti selezione del personale durante prenotazione",
      "code_block_tooltip": "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel calendario.",
      "calendar_image": "Immagine di copertina del calendario",
      "remove_image": "Rimuovi immagine",
      "calendar_image_info": "L'immagine caricata sarà visibile all'interno della Vista gruppo per il modello Neo e non apparirà sul link del singolo calendario.",
      "get_image_from_unsplash": "Migliora i tuoi contenuti visivi con",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Configura preferenze aggiuntive",
      "service_image": "Immagine di copertina del servizio",
      "service_image_description": "Seleziona un'immagine che verrà visualizzata per questo servizio nel menu dei servizi.",
      "allow_reschedule_appointment": "Consenti riprogrammazione dell'appuntamento",
      "allow_cancelling_appointment": "Consenti annullamento dell'appuntamento",
      "custom_code_placeholder": "Inserisci qui il codice personalizzato",
      "calendar_widget_style_desc": "Scegli tra il nostro widget Classico o l'elegante Neo.",
      "seats_per_slot": "Posti per fascia oraria",
      "show_staff_selection": "Selezione del personale",
      "seats_per_slot_desc": " Permetti ai prenotanti di vedere il numero di posti disponibili per ogni fascia oraria direttamente sul widget del calendario.",
      "show_staff_selection_desc": "Consenti a chi prenota di scegliere un membro del personale direttamente dal widget del calendario al momento della prenotazione dell'appuntamento. Opzione disponibile solo con il widget Neo.",
      "widget_re_order_tooltip": "Lo stile widget Classico non consente di modificare l'ordine dei widget. Prima di selezionare lo stile Classico, controlla che il selettore di data e ora sia al primo posto e che il modulo sia al secondo posto.",
      "show_staff_selection_desc_service": "Permetti ai prenotanti di scegliere un membro dello staff direttamente dal widget del calendario durante la prenotazione dell'appuntamento.",
      "switch_to_classic_widget": "Passa al widget Classico",
      "switch_to_classic_widget_desc": "Il passaggio al <b>widget Classico</b> disabiliterà automaticamente le seguenti impostazioni, in quanto non possono coesistere:",
      "form_first_disabled": "<b>Il Modulo verrà spostato nel secondo Passaggio</b> in Widget Ordina.",
      "appointment_preference_disabled": "La <b>preferenza per i nuovi appuntamenti (Prenota sempre con l'utente assegnato al {contactLabel})</b> verrà disattivata. Ciò significa che gli appuntamenti possono essere prenotati con qualsiasi membro del team disponibile, anziché essere riservati all'utente assegnato al {contactLabel}.",
      "multiple_location_disabled": "<b>Più conferenze di indirizzi</b> saranno Eliminato e solo il <b>primo Luogo aggiunto</b> verrà mantenuto.",
      "insert_custom_code_tooltip": "Personalizza lo stile del widget usando il tuo codice CSS.",
      "classic_tooltip_disabled": "Il widget classico non è supportato per i calendari di prenotazione dei corsi.",
      "show_staff_selection_disabled_tooltip": "La selezione del personale è supportata solo per il widget Neo."
    },
    "roomsAndEquipments": {
      "title": "Seleziona sala e attrezzatura",
      "description": "Scegli da un elenco di sale e attrezzature cosa verrà prenotato insieme a questo calendario.",
      "rooms": "Seleziona sale",
      "equipments": "Seleziona attrezzatura"
    }
  },
  "activity_log": {
    "activity_log": "Registro delle attività",
    "date": "Data",
    "filter_by": "Filtra per",
    "calendar_update": "Aggiornamento del calendario",
    "start_time_update": "Aggiornamento dell'orario di inizio",
    "end_time_update": "Aggiornamento dell'ora di fine",
    "title_update": "Aggiornamento titolo",
    "notes_update": "Aggiornamento delle note",
    "appointment_status_update": "Aggiornamento dello stato dell'appuntamento",
    "meeting_location_update": "Aggiornamento del luogo dell'incontro",
    "google_sync_update": "Aggiornamento sincronizzazione Google",
    "outlook_sync_update": "Aggiornamento sincronizzazione Outlook",
    "assigned_user_update": "Aggiornamento utente assegnato",
    "appointment_status": "Stato dell'appuntamento",
    "assigned_user": "Utente assegnato",
    "uploaded_to": "Caricato su",
    "cancelled": "Annullato",
    "edited": "modificato",
    "other_edits": "Altre modifiche",
    "view_details": "Visualizza dettagli",
    "all": "Tutto"
  },
  "appointment_list": {
    "group_all": "TUTTO",
    "group_primary": "PRIMARIO",
    "group_user": "UTENTI",
    "group_team": "GRUPPI",
    "group_calendar": "CALENDARI",
    "all_appointments": "Tutti gli appuntamenti",
    "my_calendar": "Il mio calendario",
    "status_all": "Tutto",
    "status_confirmed": "Confermato",
    "status_new": "Nuovo (azione richiesta)",
    "status_show": "Presentazione",
    "status_no_show": "Mancata presentazione",
    "status_cancelled": "Annullato",
    "status_invalid": "Non valido",
    "filter_date_added_desc": "Data di aggiunta (disc.)",
    "filter_start_added_desc": "Data di inizio (desc)",
    "filter_start_added_asc": "Data di inizio ascendente a partire da oggi",
    "button_new_appointment": "Nuovo appuntamento",
    "name": "Nome",
    "title": "Titolo",
    "requested_time": "Tempo richiesto",
    "date_added": "Data di aggiunta",
    "calendar": "Calendario",
    "appointment_owner": "Titolare dell'appuntamento",
    "notes": "Note",
    "status": "Stato",
    "action_view_detail": "Visualizza dettagli",
    "action_view_consent": "Visualizza consenso",
    "action_view_notes": "Visualizza note",
    "action_edit": "Modifica",
    "action_delete": "Elimina",
    "action_reschedule": "Riprogramma",
    "page_previous": "Precedente",
    "page_next": "Successivo",
    "appointment_notes": "Note dell'appuntamento",
    "close": "Chiudi",
    "confirm_delete_header": "Elimina appuntamento",
    "confirm_delete_message": "Vuoi davvero eliminare questo appuntamento? Questa azione non può essere annullata!",
    "confirm_delete_button": "Elimina",
    "confirm_update_header": "Aggiorna lo stato dell'appuntamento",
    "confirm_update_confirmed_message": "Vuoi davvero contrassegnare questo appuntamento come \"confermato\"?",
    "confirm_update_invalid_message": "Vuoi davvero contrassegnare questo appuntamento come \"non valido\"?",
    "confirm_update_showed_message": "Vuoi davvero contrassegnare questo appuntamento come \"presentazione\"?",
    "confirm_update_noshow_message": "Vuoi davvero contrassegnare questo appuntamento come \"mancata presentazione\"?",
    "confirm_update_cancelled_message": "Vuoi davvero contrassegnare questo appuntamento come \"annullato\"?",
    "confirm_update_button": "Aggiorna",
    "empty_state_title": "Nessun appuntamento trovato",
    "empty_state_description": "Nessun appuntamento trovato.",
    "disable_menu_warning": "Al momento, non disponi dell'autorizzazione per visualizzare o modificare i dettagli dell'appuntamento, poiché il contatto associato non ti è assegnato. Contatta il tuo amministratore per ricevere assistenza.",
    "no_contact_warning": "Al momento non riesci ad accedere alle informazioni del contatto. Ciò potrebbe essere dovuto al fatto che il contatto non è assegnato a te. Contatta il tuo amministratore per ricevere assistenza.",
    "consent_label": "Consenso",
    "ip_address": "IP",
    "youre_viewing_in": "Attualmente in visualizzazione in",
    "appointment_delete_msg": "<b>Nota bene:</b> l'appuntamento eliminato da qui non verrà eliminato da Calendly.",
    "rescheduled": "Riprogrammato"
  },
  "add_guest": {
    "guest_label": "Ospite/i",
    "search_placeholder": "Cerca nei contatti",
    "add_new": "Aggiungi nuovo",
    "save": "Salva",
    "close": "Chiudi",
    "name": "Nome",
    "phone": "Telefono",
    "email": "Email",
    "guest_label_count": "Numero di ospiti",
    "guest_count_error": "Il numero di ospiti deve essere compreso tra 1 e 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Dettagli del menu dei servizi",
    "select_groups_header": "Seleziona servizi",
    "arrange_groups_header": "Organizza i tuoi servizi",
    "new_service_menu": "Nuovo menu dei servizi",
    "service_menu_sub_title": "Crea un menu dei servizi personalizzato per i tuoi clienti in pochi clic",
    "quick_tip": "Puoi aggiungere gruppi al menu dei servizi",
    "service_menu_name": "Nome del menu dei servizi",
    "service_menu_description": "Descrizione",
    "service_menu_slug": "URL del servizio",
    "select_groups_calendars": "Seleziona gruppi e calendari",
    "select_groups_calendars_desc": "Aggiungi servizi al tuo menu dei servizi",
    "select_all": "Seleziona tutto",
    "arrange_groups": "Organizza ordine dei servizi",
    "arrange_groups_desc": "Determina la sequenza dei servizi nel menu dei servizi",
    "arrange_services_quicktip": "Per riorganizzare i calendari all'interno del gruppo, vai a Gruppi > Opzioni > Riorganizza calendari.",
    "enable_add_guest_desc": "Consente ai clienti di includere ospiti aggiuntivi al momento della prenotazione.",
    "enable_multiple_service_desc": "Consente ai clienti di prenotare più servizi in un unico appuntamento.",
    "enable_staff_selection_desc": "Consente ai clienti di scegliere i membri del personale preferiti quando effettuano una prenotazione.",
    "enable_add_guest": "Abilita l'aggiunta di ospiti",
    "enable_multiple_service": "Abilita la selezione di più servizi",
    "enable_staff_selection": "Abilita la selezione dei membri del personale",
    "additional_options": "Opzioni aggiuntive",
    "code_block_tooltip": "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel menu dei servizi.",
    "custom_code_placeholder": "Inserisci qui il codice personalizzato",
    "insert_custom_code": "Inserisci codice personalizzato",
    "no_service": "Nessun servizio trovato",
    "no_service_desc": " Nessun servizio trovato. Crea servizi e aggiungili ai gruppi per creare un menu dei servizi.",
    "learn_more": "Scopri di più",
    "no_service_selected": "Nessun servizio selezionato",
    "create_service_calendars": "Crea calendari dei servizi",
    "alert_description": " Per creare un menu dei servizi, devi creare dei calendari dei servizi e aggiungerli a gruppi.",
    "dont_show_again": "Non mostrare più questo",
    "service_name_required": "Il nome del menu dei servizi è obbligatorio",
    "slug_already_taken": "Questo slug è già stato preso",
    "slug_required": "Lo slug è obbligatorio",
    "please_enter_name": "Inserisci un nome",
    "service_name_placeholder": "Menu principale",
    "service_slug_placeholder": "menu principale",
    "form_label": "Modulo",
    "consent_label": "Casella di controllo del consenso",
    "consent_input_placeholder": "Aggiungi testo per l'acquisizione del consenso",
    "consent_tooltip": "Attiva questa opzione per consentire di ottenere il consenso dai {contactsLabel} quando forniscono il loro numero di telefono durante il processo di prenotazione dell'appuntamento.",
    "back_message": "Torna all'elenco",
    "saving_changes": "Just a Minute — Salvataggio l'ultima Dinamico...",
    "payment_provider_warning": "Attenzione! Al momento, i menu dei servizi supportano solo i pagamenti tramite Stripe e Authorize.net. Poiché hai un provider predefinito differente, la riscossione dei pagamenti per i calendari selezionati con i pagamenti abilitati verrà saltata.",
    "aria": {
      "consent_form_toggle": "Attiva/disattiva modulo di consenso",
      "enable_add_guest_toggle": "Attiva/disattiva l'opzione aggiungi ospite",
      "enable_multiple_services_toggle": "Attiva/disattiva l'opzione per abilitare più servizi",
      "enable_staff_selection_toggle": "Attiva/disattiva selezione del personale"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Personalizza widget del calendario",
    "works_with_neo_widget": "Funziona solo con il widget Neo",
    "customise_widget_desc": "Personalizza l'aspetto del widget: colore primario, colore di sfondo e testo del pulsante.",
    "learn_more": "Scopri di più",
    "primary_settings": "Impostazioni primarie",
    "primary_settings_desc": "Configura il colore primario, il colore di sfondo e altre preferenze per il widget per personalizzare il tuo widget del calendario.",
    "primary_color": "Colore primario",
    "primary_color_desc": "Scegli il colore di pulsanti, date, fasce orarie e azioni.",
    "background_color": "Colore di sfondo",
    "background_color_desc": "Imposta il colore di sfondo che funge da sfondo sia per il selettore di data e ora che per il modulo.",
    "button_text": "Testo del pulsante",
    "button_text_desc": "Personalizza il testo visualizzato sul pulsante quando si prenota un appuntamento.",
    "calendar_title": "Titolo del calendario",
    "calendar_title_desc": "Il nome del tuo calendario",
    "calendar_description": "Descrizione del calendario",
    "calendar_description_desc": "La descrizione inserita.",
    "calendar_details": "Dettagli del calendario",
    "calendar_details_desc": "Include informazioni come durata, data e ora, dettagli ricorrenti e fuso orario.",
    "reset_to_default": "Ripristina le impostazioni predefinite",
    "preview_widget": "Anteprima del widget",
    "calendar_title_tooltip": "Decidi se il nome del calendario e il nome del gruppo (se applicabile) devono essere visibili nel widget di prenotazione.",
    "calendar_description_tooltip": "Decidi se la descrizione del calendario deve essere visibile nel widget di prenotazione.",
    "calendar_details_tooltip": "Gli incontri Collezione Se the Chiave Dettagli come Conferenza, Selezionato Durata e dati e informazioni sulla ricorrenza (Se applicabile) devono essere visibili Attivo the Widget di prenotazione.",
    "insert_custom_code_tooltip": "Stile Widget di Personalizza tramite il tuo codice CSS .",
    "staff_selection_tooltip": "Abilita Prenotante a selezionare uno staff Membri direttamente dal Widget del calendario durante la prenotazione dell'Appuntamento. Funziona solo con Neo Widget."
  },
  "eventNotification": {
    "customFields": "Campi personalizzati",
    "customValues": "Valori personalizzati",
    "templateVariableIssueDefaultPartBefore": "Ci sono problemi con il tuo ",
    "templateVariableIssueDefaultPartHighlight": "valori personalizzati",
    "templateVariableIssueDefaultPartAfter": "; controlla e correggi prima di salvare.",
    "templateVariableInvalidListOverflow": "… e altri {count}",
    "templateVariableIssueSingle": "C'è un problema con questo valore personalizzato: {value}; correggilo prima di salvare.",
    "templateVariableIssueEmpty": "Uno o più valori personalizzati sono vuoti ({emptyPair}); aggiungi un campo valido all'interno delle parentesi.",
    "templateVariableIssueMarkup": "Alcuni valori personalizzati includono HTML o formattazione, che non sono supportati; rimuovili prima di salvare.",
    "templateVariableSaveFailed": "Non è stato possibile salvare la notifica {receiverLabel}. Prima di salvarla, correggi gli errori dei valori personalizzati.",
    "templateVariableSaveFailedGeneric": "Non è stato possibile salvare la notifica. Prima di salvarla, correggi gli errori dei valori personalizzati.",
    "guest": "Ospite",
    "assignedUser": "Utente assegnato",
    "additionalEmails": "Email aggiuntive",
    "list": {
      "booked": {
        "title": "Appuntamento prenotato (stato: non confermato)",
        "modalTitle": "appuntamento prenotato (stato: non confermato)",
        "note": "Questa notifica è inviato quando un nuovo Appuntamento è creato con stato non confermato.",
        "subTitle": "Avvisa quando un appuntamento è prenotato con stato non confermato."
      },
      "confirmation": {
        "title": "Appuntamento prenotato (stato: confermato)",
        "modalTitle": "appuntamento prenotato (stato: confermato)",
        "note": "Questa Notifica è inviato Quando un Appuntamento è Creato con O aggiornato al Confermato Stato.",
        "subTitle": "Avvisa quando un appuntamento viene confermato correttamente."
      },
      "cancellation": {
        "title": "Annullamento",
        "modalTitle": "annullamento",
        "note": "Questa notifica è inviato quando un Appuntamento viene cancellato, contrassegnato come Mancata presentazione, O contrassegnato come Non valido.",
        "subTitle": "Avvisa quando un appuntamento viene annullato."
      },
      "reschedule": {
        "title": "Riprogramma",
        "modalTitle": "riprogrammazione",
        "note": "Questa notifica viene inviato Quando un Appuntamento viene riprogrammato. Verrà attivato solo se l'Appuntamento è in Non confermato O Confermato Stato.",
        "subTitle": "Avvisa quando un appuntamento viene riprogrammato."
      },
      "reminder": {
        "title": "Promemoria",
        "modalTitle": "promemoria",
        "note": "Questa notifica è inviato come Promemoria Prima l'Appuntamento. Verrà attivato solo se l'Appuntamento è in Non confermato O Confermato Stato.",
        "subTitle": "Invia un promemoria prima dell'appuntamento."
      },
      "followup": {
        "title": "follow-up",
        "modalTitle": "follow-up",
        "note": "Questa notifica è inviata dopo l'Appuntamento come follow-up. Verrà attivato solo se l'Appuntamento è in Unconfirmed, Confermato, O Presentazione Stato.",
        "subTitle": "Invia un messaggio di follow-up dopo il completamento dell'appuntamento."
      }
    },
    "saveToastMsg": "Impostazioni salvate!",
    "saveToastMsgDesc": "Le tue modifiche sono state salvate correttamente.",
    "enableSuccess": "Notifiche attivate!",
    "disableSuccess": "Notifiche disattivate!",
    "tooltip": "Questa notifica è stata disabilitata. Abilitalo per creare qualsiasi Dinamico.",
    "enabled": "Abilitato",
    "disabled": "Disabilitato",
    "statusLabel": "Etichette di stato",
    "email": {
      "channelName": "Email",
      "noneTemplate": "Nessuno",
      "notificationLabel": "Chi dovrebbe ricevere questa notifica?",
      "sendButtonLabel": "Invia email di prova",
      "testEmailLabel": "Email di prova",
      "testEmailPlaceholder": "Inserisci l'indirizzo email del destinatario per il test",
      "body": "Corpo dell'email",
      "bodyPlaceholder": "Digita qui il tuo messaggio",
      "subject": "Oggetto",
      "subjectPlaceholder": "Inserisci l'oggetto dell'email",
      "templateLabel": "Modello di email",
      "templatePlaceholder": "Seleziona un modello di email o inizia da zero",
      "fromNamePlaceholder": "Inserisci nome",
      "fromNameLabel": "Nome mittente",
      "fromAddressLabel": "Indirizzo mittente",
      "alertEmailAddress": "Inserisci gli ID email (separati da virgole)",
      "addMore": "Aggiungi altro",
      "afterAppointmentEnds": "dopo la fine dell'appuntamento",
      "beforeAppointmentStarts": "prima dell'inizio dell'appuntamento",
      "durationLabel": "Quando desideri attivare la notifica?",
      "disableEmailNotification": "Disabilita notifiche email",
      "enableEmailNotification": "Abilita le notifiche email",
      "enableSuccess": "Notifica email abilitata!",
      "enableSuccessDesc": "Ora inizierai a ricevere questa notifica",
      "disableSuccess": "Notifica email disabilitata!",
      "disableSuccessDesc": "Non riceverai più questa notifica",
      "reset_to_default": "Ripristina a Predefinito",
      "testEmailSuccessTitle": "Email di test inviata!",
      "testEmailSuccessDesc": "L'email di prova è stata inviata correttamente a {email}",
      "testEmailErrorTitle": "Invio dell'email di prova non riuscito",
      "testEmailErrorDesc": "Si è verificato un errore durante l'invio dell'email di prova. Riprova.",
      "create_new_email_template": "Crea un nuovo modello di email",
      "templateVariableFieldSubject": "Oggetto",
      "templateVariableFieldFromName": "Nome mittente",
      "templateVariableFieldFromAddress": "Indirizzo mittente",
      "templateVariableFieldEmailBody": "Corpo dell'email"
    },
    "inApp": {
      "channelName": "in-app",
      "title": "Impostazioni di notifica",
      "enableInAppNotification": "Abilita notifica in app",
      "disableInAppNotification": "Disabilita notifica in app",
      "selectedUser": {
        "label": "Invia a",
        "helperText": "Questa notifica interna viene inviata tramite app mobili e web.",
        "placeholder": "Seleziona utente/i"
      },
      "enableSuccess": "Notifiche in-app abilitate!",
      "enableSuccessDesc": "Ora inizierai a ricevere questa notifica.",
      "disableSuccess": "Notifiche in-app disattivate!",
      "disableSuccessDesc": "Non riceverai più questa notifica."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Nessuno",
      "notificationLabel": "Chi dovrebbe ricevere questa notifica?",
      "sendButtonLabel": "Invia SMS di prova",
      "testSMSLabel": "Testa SMS (inserisci il numero di telefono con il prefisso internazionale)",
      "testSMSPlaceholder": "+12345678901",
      "body": "Messaggio SMS",
      "bodyPlaceholder": "Digita qui il tuo messaggio SMS",
      "durationLabel": "Quando vuoi attivare la notifica?",
      "disableSMSNotification": "Disabilita le notifiche SMS",
      "enableSMSNotification": "Abilita le notifiche SMS",
      "enableSuccess": "Notifica SMS abilitata!",
      "enableSuccessDesc": "Ora inizierai a ricevere questa notifica.",
      "disableSuccess": "Notifica SMS disabilitata!",
      "disableSuccessDesc": "Non riceverai più questa notifica.",
      "alertPhoneNumbers": "Inserisci i numeri di telefono (con prefissi internazionali, separati da virgole)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Aggiungi altro",
      "afterAppointmentEnds": "dopo la fine dell'appuntamento",
      "beforeAppointmentStarts": "prima dell'inizio dell'appuntamento",
      "templateLabel": "Modello di SMS",
      "templatePlaceholder": "Seleziona un modello di SMS...",
      "reset_to_default": "Ripristina le impostazioni predefinite",
      "testSmsSuccessTitle": "SMS di prova inviato!",
      "testSmsSuccessDesc": "L'SMS di prova è stato inviato correttamente a {phone}.",
      "testSmsErrorTitle": "Invio dell'SMS di prova non riuscito",
      "testSmsErrorDesc": "Si è verificato un errore durante l'invio dell'SMS di prova. Riprova.",
      "templateVariableFieldSmsBody": "Corpo del messaggio"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Chi dovrebbe ricevere questa notifica?",
      "sendButtonLabel": "Invia notifica WhatsApp di prova",
      "testWhatsAppLabel": "Testa la notifica di WhatsApp (inserisci il numero di telefono con il prefisso internazionale)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Quando vuoi attivare la notifica?",
      "alertPhoneNumbers": "Inserisci i numeri di telefono (con prefissi internazionali, separati da virgole)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Aggiungi altro",
      "afterAppointmentEnds": "dopo la fine dell'appuntamento",
      "beforeAppointmentStarts": "prima dell'inizio dell'appuntamento",
      "templateLabel": "Modello WhatsApp",
      "templatePlaceholder": "Seleziona il modello WhatsApp...",
      "noPreview": "Nessun modello selezionato",
      "documentPreview": "Documento",
      "offerEndsOn": "L'offerta termina il {date}",
      "offerCode": "Codice: {code}",
      "templateRequired": "Il modello è obbligatorio",
      "testWhatsAppSuccessTitle": "Notifica WhatsApp di prova inviata!",
      "testWhatsAppSuccessDesc": "La notifica WhatsApp di prova è stata correttamente inviata a {phone}.",
      "testWhatsAppErrorTitle": "Invio della notifica WhatsApp di prova non riuscito.",
      "testWhatsAppErrorDesc": "Si è verificato un errore durante l'invio della notifica WhatsApp di prova. Riprova.",
      "setupTitle": "Contatta il tuo cliente sulla sua app di messaggistica preferita.",
      "setupDescription": "Assisti i tuoi clienti più da vicino fornendo supporto istantaneo, inviando aggiornamenti tempestivi e creando interazioni coinvolgenti.",
      "connectWhatsApp": "Collega WhatsApp",
      "checkingStatus": "Verifica dello stato dell'account WhatsApp in corso...",
      "checkingTemplateStatus": "Verifica dello stato del modello di WhatsApp in corso...",
      "statusCheckError": "Verifica dello stato dell'account WhatsApp non riuscita.",
      "templateStatusCheckError": "Verifica dello stato del modello di WhatsApp non riuscita.",
      "setupTemplateTitle": "Completa la configurazione del modello di WhatsApp.",
      "setupTemplateDescription": "Prima di poter inviare notifiche, è necessario impostare i modelli di WhatsApp. Fai clic qui sotto per completare il processo di configurazione.",
      "loadTemplatesError": "Caricamento dei modelli di WhatsApp non riuscito.",
      "templatesRefreshed": "Modelli aggiornati correttamente",
      "templatesRefreshError": "Ricaricamento dei moduli non riuscito.",
      "templatesResolveError": "Errore durante la risoluzione dei modelli predefiniti di WhatsApp.",
      "locationNotFound": "ID luogo non trovato.",
      "settingsRedirectError": "Impossibile effettuare il reindirizzamento alle impostazioni di WhatsApp.",
      "updateNotificationError": "Aggiornamento della notifica di WhatsApp non riuscito.",
      "notificationsEnabled": "Notifiche di WhatsApp abilitate!",
      "notificationsDisabled": "Notifiche di WhatsApp disabilitate!",
      "updateError": "Errore durante l'aggiornamento delle notifiche.",
      "createNewTemplate": "Crea un nuovo modello di WhatsApp",
      "phoneValidation": {
        "countryCodeRequired": "Il numero di telefono deve iniziare con un prefisso internazionale (ad es. +1, +91, +44)",
        "digitsOnly": "Il numero di telefono deve contenere solo cifre dopo il prefisso internazionale.",
        "tooShort": "Il numero di telefono è troppo corto.",
        "tooLong": "Il numero di telefono è troppo lungo.",
        "invalid": "Numero di telefono non valido."
      },
      "errors": {
        "templateNotFound": "ID modello non trovato nelle opzioni caricate; cancellazione in corso.",
        "templateNoLongerValid": "Modello salvato non più valido; cancellazione in corso.",
        "invalidTemplateSelection": "È stato effettuato il tentativo di selezionare un modello di WhatsApp non valido.",
        "fetchingTemplates": "Errore durante il recupero dei modelli di WhatsApp.",
        "mountingCreator": "Errore durante l'inizializzazione dello strumento di creazione di modelli di WhatsApp.",
        "fetchingAfterCreation": "Errore durante il recupero dei modelli di WhatsApp dopo la creazione.",
        "updateStatus": "Errore durante l'aggiornamento dello stato di WhatsApp."
      },
      "receiverLabels": {
        "assignedUser": "Utente assegnato",
        "phoneNumbers": "Numeri di telefono aggiuntivi"
      }
    },
    "voiceAi": {
      "channelName": "Voice AI",
      "setupTitle": "Termina la configurazione di Voice AI",
      "setupDescription": "I promemoria di Voice AI richiedono alcune cose da mettere a posto prima di poterli configurare.",
      "agentLabel": "Agente vocale",
      "agentPlaceholder": "Seleziona un agente",
      "agentHelper": "L'agente che effettua la chiamata di promemoria. Se non è ancora attivo, salvando questo promemoria lo rendi attivo.",
      "openAgent": "Apri agente",
      "createAgent": "Crea agente promemoria",
      "creatingAgent": "Creazione in corso…",
      "createAgentHelper": "Sei nuovo? Crea un agente configurato per questo calendario: prenotazione, riprogrammazione e annullamento, più un messaggio di benvenuto per il promemoria che puoi modificare.",
      "agentCreated": "Agente promemoria creato e selezionato. Controlla il messaggio di benvenuto e la voce nel builder degli agenti.",
      "agentCreateFailed": "Impossibile creare l'agente promemoria. Riprova.",
      "agentCreateNoPermission": "Non hai l'autorizzazione per creare agenti Voice AI. Chiedi a un amministratore di crearne uno.",
      "requirements": {
        "title": "Prima dell'invio delle chiamate di promemoria",
        "booking": "L'agente ha bisogno di un'azione di prenotazione appuntamenti per questo calendario con riprogrammazione e annullamento attivati, così da poter cercare e modificare l'appuntamento per cui chiama. Un agente creato qui ce l'ha già.",
        "greeting": "La chiamata si apre con il messaggio di benvenuto in uscita dell'agente, come impostato sull'agente. L'appuntamento è disponibile per l'agente tramite campi di unione come {start} e {calendar}.",
        "dismiss": "Ignora"
      },
      "fromNumberLabel": "Chiama da",
      "fromNumberPlaceholder": "Seleziona un numero",
      "timingLabel": "Quando deve essere effettuata la chiamata?",
      "beforeAppointment": "prima dell'inizio dell'appuntamento",
      "timingHelper": "Le chiamate vengono effettuate tra le 8 e le 20, ora locale del contatto: con questa impostazione verranno chiamati gli appuntamenti che iniziano tra {from} e {until}.",
      "timingRangeError": "Scegli tra {min} e {max} {unit}.",
      "units": {
        "day": "giorno",
        "days": "giorni"
      },
      "consent": {
        "label": "Accetto i termini per le chiamate in uscita",
        "updatedLabel": "Accetto i termini aggiornati per le chiamate in uscita",
        "note": "Ti verrà chiesto una sola volta per questa sede.",
        "updatedNote": "I termini sono cambiati dall'ultima accettazione. Accettarli è facoltativo.",
        "termsTitle": "Termini e condizioni",
        "termsIntro": "By activating this feature, you confirm and agree that your business:",
        "terms1": "Will not use this feature in violation of applicable laws governing the making and sending of calls, including but not limited to the Telephone Consumer Protection Act (TCPA), the Telemarketing Sales Rule (TSR), applicable state telemarketing laws, and any equivalent international laws and regulations applicable to your use.",
        "terms2": "Has secured the correct level of consent from each individual before placing calls.",
        "terms3": "Is solely responsible for your compliant use of this functionality.",
        "required": "Accetta i termini per le chiamate in uscita per attivare i promemoria Voice AI."
      },
      "guidelines": {
        "title": "Come funzionano le chiamate di promemoria",
        "window": "Le chiamate vengono effettuate solo tra le 8 e le 20, ora locale del contatto, ricavata dal suo numero di telefono.",
        "oncePerDay": "Ogni contatto viene chiamato al massimo una volta al giorno, quindi viene effettuata una sola chiamata di promemoria per appuntamento.",
        "queued": "Le chiamate vengono messe in coda, quindi la composizione può iniziare qualche minuto dopo l'orario del promemoria.",
        "skips": "I contatti che hanno rifiutato le chiamate IA o hanno attivato Non disturbare vengono saltati.",
        "country": "Le chiamate vengono effettuate solo verso numeri del paese di questo account.",
        "fallback": "Se la chiamata non può essere effettuata o non riceve risposta, viene inviato il promemoria via {channel}.",
        "capabilities": "Se l'agente ha la prenotazione degli appuntamenti con riprogrammazione e cancellazione attive, il cliente può riprogrammare o annullare durante la chiamata."
      },
      "blockers": {
        "noAgent": "Pubblica almeno un agente vocale.",
        "noNumber": "Aggiungi un numero di telefono per le chiamate in arrivo.",
        "notEnabled": "Abilita Voice AI per questo account."
      },
      "agentRequired": "Seleziona un agente per effettuare la chiamata di promemoria.",
      "fromNumberRequired": "Seleziona il numero da cui partirà la chiamata di promemoria.",
      "saveError": "Impossibile salvare le impostazioni dei promemoria di Voice AI. Riprova."
    }
  },
  "smsTemplate": {
    "create_new_template": "Crea un nuovo modello di SMS",
    "create_new_template_desc": "Crea un modello di SMS riutilizzabile per le tue notifiche.",
    "template_name": "Nome del modello",
    "template_name_placeholder": "Inserisci nome del modello",
    "message": "Messaggio",
    "message_placeholder": "Digita qui il tuo messaggio SMS.",
    "create_template": "Crea modello",
    "name_required": "Il nome del modello è obbligatorio",
    "text_required": "Il testo del messaggio è obbligatorio",
    "fetch_new_templates": "Aggiorna modelli",
    "characters": "caratteri",
    "words": "parole",
    "segments": "segmenti"
  },
  "whatsappTemplate": {
    "create_new_template": "Crea un nuovo modello di WhatsApp",
    "create_new_template_desc": "Crea un modello di WhatsApp riutilizzabile per le tue notifiche.",
    "template_name": "Nome del modello",
    "template_name_placeholder": "Inserisci nome del modello",
    "message": "Messaggio",
    "message_placeholder": "Digita qui il tuo messaggio WhatsApp.",
    "create_template": "Crea modello",
    "name_required": "Il nome del modello è obbligatorio",
    "text_required": "Il testo del messaggio è obbligatorio",
    "fetch_new_templates": "Aggiorna modelli"
  },
  "archivedServices": {
    "servicesBanner": "È arrivata una nuova versione dei servizi, più potente, flessibile e intuitiva. I tuoi calendari dei servizi sono già stati trasferiti. Esplorali subito nella scheda Servizi.",
    "archivedServiceCalendars": "Calendari dei servizi (v1)",
    "check_new_services": "Controlla i nuovi servizi"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Modifica calendario",
      "share_calendar": "Condividi calendario",
      "troubleshoot_calendar": "Risolvi i problemi del calendario",
      "more_options": "Altre opzioni",
      "edit_calendar_desc": "Gestisci ogni impostazioni del calendario: Fisso disponibilità, Configura promemoria, Modifica dei limiti dell'Appuntamento e altro ancora.",
      "share_calendar_desc": "Copia e condividi il tuo Link di programmazione così Prenotante può facilmente programmare con Tu.",
      "troubleshoot_calendar_desc": "Scopri perché una fascia oraria non viene visualizzata e vedi i possibili motivi nella schermata di risoluzione dei problemi.",
      "more_options_desc": "Accedi a Impostazioni aggiuntive e attività per Gestisci il tuo calendario.",
      "read_permissions": {
        "share_description": "Concedi l'accesso ad altri utenti condividendo il link del calendario o modificando le autorizzazioni.",
        "troubleshoot_description": "Identifica e risolvi problemi come errori di sincronizzazione o eventi mancanti per un funzionamento fluido."
      },
      "next": "Successivo",
      "start_over": "Ricomincia",
      "all_set": "Tutto pronto!",
      "previous": "Precedente"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Seleziona la tua esperienza di editing",
    "select_editing_experience_desc": "Scegli se creare utilizzando il nostro editor di progettazione visuale drag-and-drop o il potente editor di codice.",
    "design_editor": "Editor di progettazione",
    "design_editor_desc": "Modifica visiva drag-and-drop.",
    "code_editor": "Editor di codice",
    "code_editor_desc": "Modifica HTML con numerose funzionalità.",
    "text_editor": "Editor di testo normale",
    "text_editor_desc": "Modifiche al testo di base, pulite e senza fronzoli.",
    "email_text_block": "Email può anche essere creata tramite Corpo Blocco. ",
    "select": "Seleziona",
    "new_template": "Nuovo modello",
    "email_block": "L'email può essere creata anche utilizzando un blocco di testo.",
    "fetch_new_templates": "Recupera i nuovi modelli"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Usa un nome e una descrizione chiari per l'incontro, in modo che chi prenota sappia esattamente cosa stia programmando.",
      "groups_share_link": "I gruppi permettono di condividere un unico link di programmazione per più calendari, consentendo ai clienti di scegliere e prenotare tra le opzioni disponibili."
    },
    "staff_location": {
      "custom_location": "Per inserire un qualsiasi indirizzo o link di tua scelta, seleziona \"Personalizzato\" come luogo dell'incontro.",
      "ask_booker_location": "Quando si seleziona \"Chiedi a chi prenota\", al momento della prenotazione a chi prenota viene chiesto di inserire il luogo dell'incontro",
      "round_robin_priority": "Le impostazioni delle priorità determinano il modo in cui gli incontri vengono assegnati quando sono disponibili più membri del personale.",
      "connect_video_integrations": "Prima di selezionarle come luogo dell'incontro, collega le integrazioni di videoconferenza dalle Impostazioni del calendario → Connessioni."
    },
    "availability": {
      "staff_availability_required": "Gli incontri possono essere prenotati solo quando c'è almeno un membro del personale selezionato disponibile.",
      "use_precreated_schedule": "Puoi utilizzare un programma di disponibilità pre-costituito dalle Impostazioni del calendario → Disponibilità, oppure puoi creare un programma personalizzato solo per questo calendario.",
      "timezone_in_schedule": "Il fuso orario per gli incontri è impostato all'interno del programma di disponibilità selezionato.",
      "event_24_hours": "Per rendere un calendario disponibile 24 ore, imposta l'intervallo di tempo dalle 00:00 alle 00:00."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Le regole di prenotazione si applicano a tutti gli incontri su questo calendario, indipendentemente dalla disponibilità del personale.",
      "minimum_scheduling_notice": "Aumenta il preavviso minimo per la programmazione per evitare le prenotazioni dell'ultimo minuto.",
      "maximum_bookings_per_slot": "Usa il numero massimo di prenotazioni per fascia oraria per controllare quanti incontri possono avvenire contemporaneamente."
    },
    "forms": {
      "custom_contact_fields": "Puoi includere campi di contatto personalizzati sia nei messaggi dei moduli che negli URL dei moduli.",
      "create_custom_form": "Per raccogliere più informazioni, crea un modulo personalizzato da Siti → Moduli → Builder e utilizzalo con questo calendario."
    },
    "payments": {
      "collected_during_booking": "I pagamenti vengono riscossi durante la prenotazione e devono essere completati prima che l'incontro sia confermato.",
      "payment_description": "Usa la descrizione del pagamento per spiegare chiaramente a cosa è destinato l'addebito."
    },
    "notifications": {
      "review_policies": "Controlla le condizioni di annullamento e riprogrammazione per evitare le modifiche dell'ultimo minuto.",
      "use_workflows": "Per l'automazione avanzata, utilizza i flussi di lavoro con il trigger \"Appuntamento prenotato\"."
    },
    "customizations": {
      "preview_widget": "Visualizza l'anteprima del widget per controllare che sia in linea con il tuo brand e il flusso di prenotazione.",
      "update_widget_language": "Le impostazioni della lingua del widget possono essere modificate da Impostazioni → Calendari → Preferenze."
    },
    "connections": {
      "google_organic_booking": "La configurazione di Google Organic Booking consente a questo calendario di ricevere prenotazioni direttamente da Google Search.",
      "external_sync_event": "Solo il calendario selezionato in Sincronizzazione esterna viene utilizzato per recuperare e inviare eventi per questo calendario."
    },
    "equipments": {
      "room_definition": "Una \"stanza\" può rappresentare qualsiasi luogo in cui vengono forniti i servizi. Potrebbe trattarsi di stanze fisiche e/o postazioni dedicate. Ad esempio: stazione di pedicure.",
      "equipment_definition": "Pensa alle \"attrezzature\" come a qualsiasi strumento o dispositivo che le aziende utilizzano per adempiere agli appuntamenti. Questo può includere macchine, dispositivi o persino sedie."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Contatti frequenti",
    "consent_form": "Modulo di consenso",
    "enable_guests": "Abilita gli ospiti",
    "auto_confirm": "Conferma automatica",
    "should_accept_payment": "Dovrebbe accettare il pagamento",
    "collect_deposit": "Riscuoti un acconto",
    "enable_charge_guests": "Abilita l'addebito agli ospiti",
    "enable_coupon": "Abilita coupon",
    "payment_live": "Pagamento in tempo reale",
    "add_availability_hour": "Aggiungi ora di disponibilità",
    "remove_availability_hour": "Rimuovi l'ora di disponibilità",
    "copy_availability_hour": "Copia l'ora di disponibilità",
    "close_modal": "Chiudi finestra modale",
    "add_custom_slot": "Aggiungi fascia oraria personalizzata",
    "remove_custom_slot": "Rimuovi fascia oraria personalizzata",
    "edit_custom_slot": "Modifica fascia oraria personalizzata",
    "update_frequency": "Frequenza di aggiornamento",
    "show_calendar_title": "Mostra il titolo del calendario",
    "show_calendar_description": "Mostra descrizione del calendario.",
    "show_calendar_details": "Mostra dettagli del calendario",
    "allow_reschedule": "Consenti riprogrammazione",
    "allow_cancellation": "Consenti annullamento",
    "category_actions": "Azioni categoria",
    "show_seats_per_slot": "Mostra i posti per le fasce orarie",
    "add_more": "Aggiungi altro",
    "same_user_assignment_toggle": "Interruttore dell'assegnazione dello stesso utente"
  },
  "placeholders": {
    "pixel_id": "ID pixel",
    "select_one": "Selezionane uno",
    "meeting_location": "Luogo dell'incontro",
    "schedule_meeting": "Programma incontro",
    "notes": "Note",
    "select_users": "Seleziona utenti",
    "please_select": "Seleziona"
  },
  "alt_text": {
    "payment_provider": "Fornitore di servizi di pagamento",
    "no_calendars": "Nessun calendario",
    "date_specific_hours": "orari specifici per data",
    "custom_widget_image": "Immagine widget personalizzata",
    "service_calendar": "Calendario dei servizi",
    "event_calendar": "Calendario degli eventi",
    "round_robin_booking": "Prenotazione a rotazione",
    "class_booking": "Prenotazione del corso",
    "collective_booking": "Prenotazione di gruppo",
    "calendar_cover_image": "Immagine di copertina del calendario",
    "email_notification_switch": "Interruttore delle notifiche via email",
    "email_template_icon": "Icona del modello di email",
    "in_app_notification_switch": "Interruttore delle notifiche in app",
    "sms_notification_switch": "Interruttore delle notifiche SMS",
    "whatsapp_notification_switch": "Interruttore delle notifiche WhatsApp",
    "no_service_found": "Nessun servizio trovato",
    "no_group_found": "Nessun gruppo trovato",
    "sync_icon": "Icona di sincronizzazione",
    "sync_type": "Tipo di sincronizzazione",
    "test1": "test1",
    "test2": "test2",
    "voice_ai_notification_switch": "Interruttore notifiche Voice AI"
  },
  "tooltips": {
    "text_color": "Colore del testo",
    "background_color": "Colore di sfondo",
    "strikethrough": "Testo barrato",
    "superscript": "Apice",
    "subscript": "Pedice",
    "inline_code_block": "Blocco di codice in linea",
    "code_block": "Blocco di codice",
    "block_quote": "Citazione a blocco",
    "more": "Più",
    "upload": "Carica",
    "image_upload_tooltip": "PNG, JPEG, JPG o GIF (dimensioni massime: 180x180 px | dimensioni massime: 2,5 MB).",
    "custom_values": "Valori personalizzati",
    "text_wrap": "Testo a capo",
    "trigger_links": "Link di attivazione",
    "text_align": "Allineamento del testo"
  },
  "labels": {
    "reset_style": "Ripristina stile",
    "reset_document_style": "Reimpostare lo stile del documento",
    "source_code": "Codice fonte",
    "success": "Operazione completata",
    "edit": "Modifica",
    "submit": "Salva",
    "cancel": "Annulla",
    "payment": "Pagamento",
    "here_is_the_link": "Ecco il link:",
    "here_is_the_embed_code": "Ecco il codice di incorporamento:",
    "service_calendar": "Calendario dei servizi",
    "collective_booking": "Prenotazione di gruppo",
    "class_booking": "Prenotazione del corso",
    "round_robin_booking": "Prenotazione a rotazione",
    "event_calendar": "Calendario degli eventi",
    "personal_booking": "Prenotazione personale",
    "service_booking": "Prenotazione dei servizi",
    "calendar_id": "ID calendario"
  },
  "validation_messages": {
    "calendar_group_name_required": "Il nome del gruppo di calendari è obbligatorio.",
    "calendar_group_description_required": "La descrizione del gruppo di calendari è obbligatoria.",
    "slug_required": "Lo slug è obbligatorio.",
    "slug_not_valid": "Questo slug non è valido.",
    "slug_already_taken": "Questo slug è già stato preso.",
    "error_validating_slug": "Errore durante la convalida dello slug.",
    "please_enter_name": "Inserisci un nome.",
    "room_name_required": "Il nome della stanza è obbligatorio",
    "equipment_name_required": "Il nome dell'attrezzatura è obbligatorio.",
    "subject_required": "L'argomento è obbligatorio.",
    "this_is_required": "Questo campo è obbligatorio.",
    "calendar_group_slug_required": "Lo slug del gruppo di calendari è obbligatorio.",
    "capacity_mandatory": "La capacità è obbligatoria.",
    "capacity_cannot_be_zero": "La capacità non può essere zero.",
    "capacity_should_be_a_number": "La capacità deve essere un numero.",
    "capacity_cannot_be_negative": "La capacità non può essere negativa.",
    "capacity_should_be_a_whole_number": "La capacità deve essere un numero intero.",
    "quantity_mandatory": "La quantità è obbligatoria",
    "quantity_cannot_be_zero": "La quantità non può essere zero.",
    "quantity_should_be_a_number": "La quantità deve essere un numero.",
    "quantity_cannot_be_negative": "La quantità non può essere negativa.",
    "quantity_should_be_a_whole_number": "La quantità deve essere un numero intero.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "La quantità non può essere inferiore alle attrezzature fuori servizio.",
    "out_of_service_value_should_be_a_number": "Il valore delle attrezzature fuori servizio deve essere un numero.",
    "out_of_service_cannot_be_negative": "Il valore fuori servizio non può essere negativo",
    "out_of_service_equipments_qty": "Le attrezzature fuori servizio non possono essere più numerose della quantità effettiva di attrezzature.",
    "out_of_service_whole_number": "Il valore delle attrezzature fuori servizio deve essere un numero intero.",
    "slot_duration_required": "La durata della fascia oraria è obbligatoria.",
    "slot_duration_integer": "La durata della fascia oraria deve essere un numero intero.",
    "meeting_duration_validation": "La durata della riunione deve essere compresa tra 1 minuto e 12 ore",
    "seats_class_required": "Il campo dei posti per corso è obbligatorio.",
    "seats_class_integer": "Il valore dei posti per corso deve essere un numero intero.",
    "seats_class_validation": "Questo valore non può essere maggiore di 9999 o inferiore a 0.",
    "meeting_location_required": "Il luogo dell'incontro è obbligatorio.",
    "meeting_location_empty": "Inserisci un valore per tutti i tipi di luogo.",
    "meeting_location_duplicate": "Non è consentito un valore duplicato per lo stesso tipo di luogo.",
    "meeting_location_booker_multiple": "Ask the Booker non è consentito per più membri del team."
  },
  "custom_values": {
    "assigned_user": "Utente assegnato",
    "full_name": "Nome e cognome",
    "first_name": "Nome",
    "last_name": "Cognome",
    "email": "Email",
    "phone": "Telefono",
    "twilio_phone": "Telefono Twilio",
    "account": "Account",
    "name": "Nome",
    "full_address": "Indirizzo completo",
    "city": "Città",
    "state": "Stato",
    "country": "Paese",
    "postal_code": "Codice postale",
    "contact": "Contatto",
    "address1": "Indirizzo 1",
    "timezone": "Fuso orario",
    "user": "Utente",
    "appointment": "Appuntamento",
    "start_date_time": "Data e ora di inizio",
    "start_date": "Data di inizio",
    "start_time": "Ora di inizio",
    "end_date_time": "Data e ora di fine",
    "end_date": "Data di fine",
    "end_time": "Ora di fine",
    "meeting_location": "Luogo dell'incontro"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "lc_meet": "Sala riunioni",
    "phone": "Telefono",
    "full_address": "Indirizzo completo",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Personalizzato"
  },
  "duration_units": {
    "minutes": "Minuti",
    "hours": "Ore"
  },
  "widget_styles": {
    "classic": "Classico",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Menu dei servizi",
    "rooms": "Stanze",
    "equipments": "Attrezzature"
  },
  "lsa": {
    "categories": {
      "accountant": "Contabilità",
      "acupuncturist": "Agopuntura",
      "air_duct_cleaner": "Pulizia dei condotti dell'aria",
      "alcohol_treatment": "Servizi per il trattamento dell'alcolismo",
      "animal_shelter": "Servizi di salvataggio animali",
      "appliance_repair": "Riparazione di elettrodomestici",
      "architect": "Architettura",
      "assisted_living": "Servizi di residenza assistita",
      "babysitter": "Servizio di babysitter",
      "bankruptcy_lawyer": "Legge fallimentare",
      "beauty_school": "Scuola di bellezza",
      "business_lawyer": "Diritto commerciale",
      "car_repair": "Servizi auto",
      "carpenter": "Carpenteria",
      "carpet_cleaning": "Pulizia dei tappeti",
      "child_care": "Servizi di assistenza all'infanzia",
      "chiropractor": "Servizi di chiropratica",
      "cleaning_service": "Pulizia della casa",
      "contract_lawyer": "Diritto contrattuale",
      "countertop_pro": "Servizi per piani di lavoro",
      "criminal_lawyer": "Diritto penale",
      "dance_instructor": "Scuola di danza",
      "disability_lawyer": "Legge sulla disabilità",
      "driving_instructor": "Scuola di guida",
      "dui_lawyer": "Legge sulla guida in stato di ebbrezza",
      "electrician": "Elettrico",
      "energy_efficiency_pro": "Servizi di efficienza energetica",
      "estate_lawyer": "Diritto immobiliare",
      "event_planner": "Pianificazione eventi",
      "family_lawyer": "Diritto di famiglia",
      "fencing_pro": "Scherma",
      "financial_planner": "Pianificazione finanziaria",
      "first_aid_trainer": "Corsi di primo soccorso",
      "flooring_pro": "Pavimentazione",
      "foundation_pro": "Fondamenti",
      "funeral_home": "Servizi funebri",
      "garage_door_pro": "Porta del garage",
      "general_contractor": "Lavoretti in casa",
      "handyman": "Tuttofare",
      "home_inspector": "Ispezione domestica",
      "home_security": "Servizi di sicurezza domestica",
      "home_theater": "Servizi Home Theater",
      "hvac": "HVAC",
      "immigration_lawyer": "Legge sull'immigrazione",
      "interior_designer": "Progettazione d'interni",
      "ip_lawyer": "Diritto della proprietà intellettuale",
      "junk_removal": "Rimozione di rifiuti",
      "labor_lawyer": "Diritto del lavoro",
      "landscaper": "Progettazione di giardini",
      "language_instructor": "Formazione linguistica",
      "lawn_care": "Cura del prato",
      "litigation_lawyer": "Diritto processuale",
      "locksmith": "Fabbro",
      "malpractice_lawyer": "Diritto della negligenza professionale",
      "massage_center": "Servizi di Massaggio",
      "massage_school": "Scuola di Massaggio",
      "mover": "Traslochi",
      "nursing_home": "Servizio di assistenza domiciliare",
      "painter": "Pittura",
      "personal_injury_lawyer": "Diritto delle lesioni personali",
      "personal_trainer": "Personal Training",
      "pest_control": "Controllo dei parassiti",
      "pet_adoption": "Servizi di adozione di animali domestici",
      "pet_boarding": "Pensione per animali domestici",
      "pet_grooming": "Toelettatura per animali domestici",
      "pet_trainer": "Addestramento di animali domestici",
      "photographer": "Fotografia",
      "plumber": "Idraulica",
      "pool_cleaner": "Pulizia della piscina",
      "pool_contractor": "Costruzione di piscine",
      "preschool": "Scuola dell'infanzia",
      "psychologist": "Servizi di Psicologia",
      "real_estate_agent": "Immobili",
      "real_estate_lawyer": "Diritto Immobiliare",
      "rehab": "Servizi di riabilitazione",
      "roofer": "Tetti e coperture",
      "sewage_pro": "Servizi per il sistema fognario",
      "siding_pro": "Rivestimento",
      "smart_home": "Servizi per la casa intelligente",
      "snow_removal": "Servizi di rimozione della neve",
      "spa": "Servizi spa",
      "tax_lawyer": "Diritto tributario",
      "tax_specialist": "Servizi fiscali",
      "therapist": "Terapia",
      "towing_pro": "Assistenza stradale",
      "traffic_lawyer": "Diritto della circolazione stradale",
      "tree_service": "Servizi di giardinaggio",
      "tutor": "Tutoraggio",
      "upholstery_cleaner": "Pulizia tappezzeria",
      "veterinarian": "Servizi veterinari",
      "videographer": "Servizi video",
      "water_damage": "Servizi di riparazione danni da acqua",
      "weight_loss_service": "Servizi per la perdita di peso",
      "window_cleaner": "Pulizia delle finestre",
      "window_repair": "Servizi per finestre",
      "windshield_repair_pro": "Vetri per auto",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Altro",
      "bankruptcy_tax_litigation": "Contenzioso fiscale in materia di fallimento",
      "bookkeeping": "Contabilità",
      "business_consulting": "Consulenza aziendale",
      "debt_collection_relief": "Sgravio recupero crediti",
      "irs_representation_resolution": "Rappresentanza e risoluzione con l'IRS",
      "payroll": "Libri paga",
      "tax_planning_business": "Pianificazione fiscale aziendale",
      "tax_planning_individual": "Pianificazione fiscale individuale",
      "tax_return_business": "Studio commercialista",
      "tax_return_individual": "Dichiarazione dei redditi individuale",
      "trusts_estates_accounting": "Contabilità per trust e patrimoni",
      "acupressure": "Digitopressione",
      "acupuncture": "Agopuntura",
      "acupuncturist_other": "Altro",
      "cupping": "Coppettazione",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Terapia del calore",
      "herbal_therapy": "Terapia erboristica",
      "infrared_therapy": "Terapia a infrarossi",
      "moxibustion": "Moxibustione",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Pulizia dei condotti dell'aria",
      "air_duct_filter_replacement": "Sostituzione filtri",
      "air_duct_other": "Altro",
      "dryer_vent_cleaning": "Pulizia dello sfiato dell'asciugatrice",
      "furnace_cleaning": "Pulizia della caldaia",
      "indoor_air_quality_testing": "Test della qualità dell'aria interna",
      "alcohol_treatment_other": "Altro",
      "animal_shelter_cat_adoption": "Adozione di gatti",
      "animal_shelter_dog_adoption": "Adozione di cani",
      "animal_shelter_other": "Altro",
      "animal_shelter_other_animal_adoption": "Altre adozioni di animali",
      "animal_shelter_other_veterinary_services": "Altri servizi veterinari",
      "animal_shelter_spay_neuter": "Sterilizzazione o castrazione",
      "animal_shelter_vaccinations": "Vaccinazioni",
      "lost_stray_found_animals": "Animali smarriti, randagi o ritrovati",
      "pet_license": "Licenza per animali domestici",
      "pet_surrender": "Cessione di animali domestici",
      "appliance_other": "Altro",
      "repair_dishwasher": "Ripara la lavastoviglie",
      "repair_dryer": "Ripara l'asciugatrice",
      "repair_freezer": "Riparazione congelatore",
      "repair_microwave": "Riparazione microonde",
      "repair_oven": "Ripara il forno",
      "repair_refrigerator": "Riparazione frigorifero",
      "repair_refrigerator_freezer": "Riparazione frigorifero / congelatore",
      "repair_stove_cooktop": "Riparazione fornello / piano cottura",
      "repair_stove_cooktop_oven": "Riparazione fornello / piano cottura / forno",
      "repair_washer": "Riparazione lavatrice",
      "repair_washer_dryer": "Riparazione lavatrice / asciugatrice",
      "3d_architectural_rendering": "Rendering architettonico 3D",
      "adaptive_reuse_historical_renovation": "Riutilizzo adattivo e ristrutturazione storica",
      "architect_other": "Altro",
      "architectural_designing": "Progettazione architettonica",
      "architectural_engineering": "Ingegneria Architettonica",
      "building_code_analysis_permit_coordination": "Analisi del codice e permessi",
      "consulting": "Consulenza",
      "home_building_improvement": "Costruzione e miglioramento della casa",
      "interior_design_architect": "Design degli interni",
      "planning_zoning_approval_assistance": "Approvazione di pianificazione e zonizzazione",
      "project_managing_architect": "Gestione dei progetti",
      "site_master_planning": "Pianificazione generale del sito",
      "assisted_living_housekeeping_and_laundry": "Pulizie e lavanderia",
      "assisted_living_meal_services": "Servizi di ristorazione",
      "assisted_living_memory_care": "Cura della memoria",
      "assisted_living_other": "Altro",
      "assisted_living_rehabilitation_services": "Servizi di riabilitazione",
      "assisted_living_transportation": "Trasporto",
      "assisted_living_wellness_programs": "Programmi di benessere",
      "daily_living_assistance": "Assistenza per la vita quotidiana",
      "medication_management": "Gestione dei farmaci",
      "short_term_stays": "Soggiorni a breve termine",
      "social_and_recreational_activities": "Attività ricreative",
      "babysitter_other": "Altro",
      "event_babysitting": "Servizio di babysitter per eventi",
      "homework_assistance": "Assistenza per i compiti",
      "housekeeping_laundry": "Pulizie e lavanderia",
      "meal_preparation": "Preparazione dei pasti",
      "nanny_services": "Servizi di babysitter",
      "overnight_babysitting": "Servizio di babysitter notturno",
      "pick_up_and_drop_off": "Prelievo e accompagnamento",
      "shopping_errand": "Shopping e commissioni",
      "special_needs_care": "Assistenza per esigenze speciali",
      "virtual_babysitting": "Servizio di babysitter virtuale",
      "agriculture_bankruptcy": "Fallimento agricolo",
      "bankruptcy_lawyer_other": "Altro",
      "bankruptcy_litigation": "Contenzioso per bancarotta",
      "chapter_11_bankruptcy": "Fallimento Chapter 11",
      "chapter_13_bankruptcy": "Fallimento Chapter 13",
      "chapter_7_bankruptcy": "Fallimento Chapter 7",
      "corporate_bankruptcy": "Fallimento aziendale",
      "creditor_harassment": "Molestie da parte dei creditori",
      "debt_settlement": "Liquidazione del debito",
      "foreclosure_bankruptcy_lawyer": "Pignoramento",
      "personal_bankruptcy": "Fallimento personale",
      "repossession": "Pignoramento",
      "wage_garnishment": "Pignoramento dello stipendio",
      "beauty_school_barbering": "Barbiere",
      "beauty_school_business_management": "Gestione aziendale",
      "beauty_school_cosmetology": "Cosmetologia",
      "beauty_school_esthetics": "Estetica",
      "beauty_school_hair_cutting": "Taglio dei capelli",
      "beauty_school_hair_design": "Design dei capelli",
      "beauty_school_makeup": "Trucco",
      "beauty_school_massage_therapy": "Massaggi",
      "beauty_school_nail_technology": "Tecnologia delle unghie",
      "beauty_school_other": "Altro",
      "beauty_school_retail_training": "Formazione retail",
      "banking_finance_law": "Banche e finanza",
      "business_lawyer_other": "Altro",
      "business_licenses_permits": "Licenze e permessi d'impresa",
      "business_litigation": "Contenzioso commerciale",
      "business_taxes": "Tasse aziendali",
      "business_transactions_business_lawyer": "Transazioni commerciali",
      "commercial_bankruptcy": "Fallimento commerciale",
      "commercial_contracts_business_lawyer": "Contratti commerciali",
      "employment_law_business_lawyer": "Diritto del lavoro",
      "incorporation_restructuring": "Incorporazione e ristrutturazione",
      "insurance_law": "Diritto delle assicurazioni",
      "intellectual_property_law": "Diritto della proprietà intellettuale",
      "mergers_acquisitions_business_lawyer": "Fusioni e acquisizioni",
      "partnership_agreements_business_lawyer": "Accordi di partnership",
      "patents_copyrights_trademarks": "Brevetti, diritti d'autore e marchi",
      "securities_law": "Diritto dei titoli",
      "shareholder_disputes": "Controversie tra azionisti",
      "air_and_cabin_filter": "Filtro aria e abitacolo",
      "battery": "Batteria",
      "body_and_trim": "Carrozzeria e rifiniture",
      "brakes": "Freni",
      "car_air_conditioning": "Aria condizionata",
      "car_electrical": "Elettrico",
      "car_repair_other": "Altro",
      "check_engine_light_diagnostic": "Controllo diagnostica luci motore",
      "exhaust": "Scappamento",
      "oil_change": "Cambio olio",
      "steering_suspension": "Sterzo / Sospensione",
      "tires": "Pneumatici",
      "transmission": "Trasmissione",
      "cabinetry": "Mobili su misura",
      "carpenter_other": "Altro",
      "decking": "Pavimenti in legno per esterni",
      "drywalling": "Cartongesso",
      "fencing": "Recinzioni",
      "general_installations": "Installazioni Generali",
      "general_repairs_maintenance": "Riparazioni e manutenzione generali",
      "remodeling": "Ristrutturazione",
      "shelving_storage": "Scaffalature e stoccaggio",
      "carpet_cleaning_other": "Altro",
      "clean_area_rugs": "Pulizia tappeti",
      "clean_carpet": "Pulizia moquette",
      "clean_drapes_and_curtains": "Pulizia di tende e tendaggi",
      "clean_upholstery": "Pulizia di tappezzeria",
      "remove_pet_stains_and_odors": "Rimozione di macchie e odori di animali domestici",
      "after_school_care": "Assistenza doposcuola",
      "all_hours_daycare": "Asilo a tutte le ore",
      "bilingual_daycare": "Asilo bilingue",
      "child_care_other": "Altro",
      "drop_in_daycare": "Asilo nido",
      "full_time_daycare": "Asilo a tempo pieno",
      "in_home_daycare": "Asilo a domicilio",
      "infant_programs": "Programmi per l'infanzia",
      "part_time_daycare": "Asilo part-time",
      "pre_kindergarten_programs": "Programmi pre-scuola materna",
      "preschool_programs": "Programmi prescolari",
      "school_age_programs": "Programmi per bambini in età scolare",
      "special_needs_daycare": "Asilo per bambini con bisogni speciali",
      "summer_daycare": "Asilo estivo",
      "toddler_programs": "Programmi per bambini in età prescolare",
      "weekend_daycare": "Asilo nel weekend",
      "chiropractor_acupuncture": "Agopuntura",
      "chiropractor_chiropractic": "Chiropratica",
      "chiropractor_massage_therapy": "Massaggi",
      "chiropractor_other": "Altro",
      "diagnosis": "Diagnosi",
      "eastern_medicine": "Medicina orientale",
      "exercise_counseling": "Consulenza sull'esercizio fisico",
      "pain_management": "Gestione del dolore",
      "physical_therapy": "Fisioterapia",
      "spinal_adjustments": "Aggiustamenti spinali",
      "sports_medicine": "Medicina dello sport",
      "cleaner_other": "Altro",
      "deep_clean": "Pulizia profonda",
      "moving_clean": "Pulizia traslochi",
      "office_clean": "Pulizia uffici",
      "standard_clean": "Standard Pulito",
      "assignment_of_contract": "Assegnazione del contratto",
      "business_transactions_contract_lawyer": "Transazioni commerciali",
      "commercial_contracts_contract_lawyer": "Contratti commerciali",
      "contract_dispute": "Controversia contrattuale",
      "contract_lawyer_other": "Altro",
      "contract_negotiation": "Negoziazione di contratti",
      "contract_review": "Revisione di contratti",
      "employment_contracts_contract_lawyer": "Contratti di lavoro",
      "franchise_agreements": "Accordi di franchising",
      "mergers_acquisitions_contract_lawyer": "Fusioni e acquisizioni",
      "non_disclosure_agreements_contract_lawyer": "Accordi di non divulgazione",
      "partnership_agreements_contract_lawyer": "Accordi di partnership",
      "power_of_attorney_contract_lawyer": "Procura",
      "security_agreements": "Accordi di sicurezza",
      "warranties": "Garanzie",
      "bathroom_countertops": "Piani di lavoro per bagni",
      "bathroom_wall_panels": "Pannelli per pareti del bagno",
      "countertop_design": "Progettazione di piani di lavoro",
      "countertop_installation": "Installazione del piano di lavoro",
      "countertop_pro_other": "Altro",
      "fireplace_facade": "Facciate di camini",
      "granite_countertops": "Piani di lavoro in granito",
      "kitchen_countertops": "Piani da cucina",
      "kitchen_wall_panels": "Pannelli per pareti della cucina",
      "laminate_countertops": "Piani di lavoro laminati",
      "marble_countertops": "Piani di lavoro in marmo",
      "quartz_countertops": "Piani di lavoro in quarzo",
      "remodeling_countertop_pro": "Ristrutturazione",
      "repair_maintenance_countertop_pro": "Riparazione e manutenzione",
      "stone_slab_countertops": "Piani di lavoro in lastre di pietra",
      "tile_countertops": "Piani di lavoro in piastrelle",
      "corporate_representation": "Rappresentanza aziendale",
      "criminal_immigration_defense": "Difesa penale in materia di immigrazione",
      "criminal_lawyer_other": "Altro",
      "domestic_violence": "Violenza domestica",
      "drug_possession": "Possesso di droga",
      "duis_reckless_driving": "Guida in stato di ebbrezza e guida spericolata",
      "expungement": "Cancellazione",
      "federal_crimes": "Reati federali",
      "felonies": "Reati gravi",
      "petty_crimes_misdemeanors": "Reati minori e contravvenzioni",
      "restraining_orders": "Ordini restrittivi",
      "sex_offenses": "Reati sessuali",
      "three_strikes_law": "Three-strikes Law",
      "dance_instructor_african": "Africano",
      "dance_instructor_ballet": "Balletto",
      "dance_instructor_ballroom": "Sala da ballo",
      "dance_instructor_belly": "Pancia",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Contemporaneo",
      "dance_instructor_folk_traditional": "Folk e tradizionale",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Corsi per bambini",
      "dance_instructor_latin": "Latino",
      "dance_instructor_modern": "Moderno",
      "dance_instructor_other": "Altro",
      "dance_instructor_tap": "Tocca",
      "dance_instructor_wedding": "Matrimonio",
      "disability_hearings": "Udienze sulla disabilità",
      "disability_lawyer_other": "Altro",
      "long_term_disability": "Invalidità a lungo termine",
      "short_term_disability": "Disabilità a breve termine",
      "social_security_disability_insurance": "Assicurazione per l'invalidità della previdenza sociale",
      "ssa_claim_reconsideration": "Riconsiderazione della richiesta SSA",
      "ssa_disability_appeals": "Ricorsi per invalidità SSA",
      "ssa_disability_applications": "Domande di invalidità SSA",
      "ssa_disability_benefits": "Prestazioni di invalidità SSA",
      "ssa_family_benefits": "Prestazioni familiari SSA",
      "ssa_impairment_listings": "Elenchi delle menomazioni SSA",
      "supplemental_security_income": "Supplemental Security Income",
      "veterans_disability_benefits": "Prestazioni di invalidità per veterani",
      "workers_compensation_disability_lawyer": "Risarcimento per infortunio sul lavoro",
      "behind_the_wheel_lessons": "Lezioni di guida pratica",
      "commercial_license_training": "Formazione sulle licenze commerciali",
      "defensive_driving_lessons": "Lezioni di guida difensiva",
      "drivers_education_classes": "Corsi di formazione alla guida",
      "driving_instructor_other": "Altro",
      "manual_transmission_lessons": "Lezioni di guida con cambio manuale",
      "motorcycle_lessons": "Lezioni di motociclismo",
      "traffic_school": "Scuola guida",
      "dui_dwi_dui_lawyer": "Guida in stato di ebbrezza (DUI/DWI)",
      "dui_injuries_dui_lawyer": "Guida in stato di ebbrezza con lesioni",
      "dui_lawyer_other": "Altro",
      "dui_with_accident": "Guida in stato di ebbrezza con incidente",
      "felony_dui": "Reato di guida in stato di ebbrezza",
      "invalid_tests": "Test non validi",
      "multiple_offenses": "Violazioni multiple",
      "reckless_driving_dui_lawyer": "Guida spericolata",
      "underage_dui": "Guida in stato di ebbrezza da parte di minorenni",
      "electric_car_charger": "Installazione caricabatteria per auto elettrica",
      "electrician_other": "Altro",
      "electrician_remodeling": "Ristrutturazione",
      "install_fan": "Installazione ventola",
      "install_ground_wire": "Installazione cavo di terra",
      "install_light_fixtures": "Installazione apparecchi di illuminazione",
      "install_outdoor_lighting": "Installa l'illuminazione esterna",
      "install_outlets_switches": "Installa prese o interruttori",
      "install_security_system": "Installazione sistema di sicurezza",
      "relocate_outlets_switches": "Riposizionamento prese o interruttori",
      "repair_fan": "Ripara la ventola",
      "repair_light_fixtures": "Riparazione apparecchi di illuminazione",
      "repair_outlets_switches": "Riparazione prese o interruttori",
      "repair_panel": "Riparazione pannello",
      "replace_upgrade_panel": "Sostituisci o aggiorna il pannello",
      "restore_power": "Ripristina l'alimentazione",
      "energy_efficiency_pro_other": "Altro",
      "charitable_giving": "Donazioni di beneficenza",
      "contests_litigation": "Controversie / contenziosi",
      "deeds": "Atti",
      "estate_lawyer_other": "Altro",
      "estate_planning_lawyer": "Pianificazione patrimoniale",
      "guardianship_estate_lawyer": "Tutela",
      "medical_power_of_attorney": "Procura medica",
      "power_of_attorney_estate_lawyer": "Procura",
      "probate_estate_lawyer": "Avvocato specializzato in successioni",
      "trusts": "Trust",
      "wills": "Testamenti",
      "anniversary_planner": "Anniversario",
      "baby_shower_planner": "Baby shower",
      "bar_and_bat_mitzvah_planner": "Bar e Bat Mitzvah",
      "birthday_party": "Festa di compleanno",
      "children_party": "Festa per bambini",
      "corporate_and_conference_planner": "Aziendali e conferenze",
      "event_planner_other": "Altro",
      "quinceanera_planner": "Quinceañera",
      "religious_event": "Evento religioso",
      "retirement_party": "Festa di pensionamento",
      "school_event": "Evento scolastico",
      "theme_party": "Festa a tema",
      "wedding_and_engagement_planner": "Matrimonio e fidanzamento",
      "adoption": "Adozione",
      "child_support": "Mantenimento dei figli",
      "contested_divorce": "Divorzio contestato",
      "debt_division": "Divisione del Debito",
      "family_lawyer_other": "Altro",
      "guardianship_family_lawyer": "Tutela",
      "mediation_family_lawyer": "Mediazione",
      "modifications_of_orders": "Modifica degli ordini",
      "parent_timesharing": "Condivisione del tempo genitoriale",
      "paternity": "Paternità",
      "prenuptial_postnuptial_agreements": "Accordi prematrimoniali e matrimoniali",
      "probate_family_lawyer": "Successione",
      "property_divisions": "Divisione proprietà",
      "protective_orders_domestic_violence_issues": "Ordini restrittivi",
      "spousal_support_alimony": "Mantenimento del coniuge e alimenti",
      "uncontested_divorce": "Divorzio consensuale",
      "custom_construction": "Costruzione personalizzata",
      "fence_design": "Progettazione di recinzioni",
      "fencing_other": "Altro",
      "installation_fencing_pro": "Installazione della recinzione",
      "repairs_maintenance_fencing_pro": "Riparazioni e manutenzione",
      "education_savings": "Risparmi per la formazione",
      "estate_financial_planning": "Pianificazione finanziaria per la successione",
      "financial_planning": "Pianificazione finanziaria",
      "financial_planning_other": "Altro",
      "home_purchase": "Acquisto casa",
      "insurance": "Assicurazione",
      "investment_advising": "Consulenza in materia di investimenti",
      "retirement_savings": "Pensionamento",
      "tax_planning": "Pianificazione fiscale",
      "advanced_cardiac_life_support": "Supporto cardiaco avanzato",
      "aed_defibrillator": "DAE - Defibrillatore",
      "basic_life_support": "Supporto vitale semplice",
      "cpr": "RCP",
      "first_aid": "Pronto soccorso",
      "first_aid_trainer_other": "Altro",
      "pediatric_advanced_life_support": "Supporto vitale avanzato pediatrico",
      "pediatric_cpr_first_aid": "RCP e primo soccorso pediatrico",
      "pet_cpr_first_aid": "RCP e primo soccorso per animali domestici",
      "wilderness_first_aid": "Primo soccorso nella natura",
      "baseboards": "Battiscopa",
      "carpet": "Tappeto",
      "flooring_other": "Altro",
      "hardwood": "Legno duro",
      "installation_flooring_pro": "Installazione di pavimenti",
      "marble": "Marmo",
      "polishing": "Lucidatura dei pavimenti",
      "refinishing": "Rifinitura dei pavimenti",
      "repair_maintenance_flooring_pro": "Riparazione e manutenzione pavimenti",
      "stair_flooring": "Pavimentazione per scale",
      "tile": "Piastrelle",
      "wood_floor_sanding": "Levigatura del pavimento in legno",
      "basement_waterproofing": "Impermeabilizzazione del seminterrato",
      "crawl_spaces": "Fondamenta a vespaio",
      "foundation_drainage": "Drenaggio delle fondamenta",
      "foundation_installation": "Installazione delle fondamenta",
      "foundation_pro_other": "Altro",
      "foundation_raising": "Innalzamento di fondamenta",
      "repairs_maintenance_foundation_pro": "Riparazioni e manutenzione",
      "slab_foundation": "Fondamenta a lastra",
      "steel_pier_pilings": "Fondazioni con pilastri in acciaio",
      "water_moisture_control": "Controllo dell'acqua e dell'umidità",
      "burials": "Sepolture",
      "caskets": "Bare",
      "cremation": "Cremazione",
      "funeral_home_flowers": "Fiori",
      "funeral_home_other": "Altro",
      "funeral_home_transportation_transfers": "Trasporti e trasferimenti",
      "funeral_home_veteran_services": "Servizi per i veterani",
      "funerals": "Funerali",
      "gravestones": "Lapidi",
      "grief_services": "Servizi di supporto al lutto",
      "memorials": "Memoriali",
      "urns": "Urne",
      "garage_door_other": "Altro",
      "general_maintenance": "Manutenzione Generale",
      "install_garage_door": "Installazione porte garage",
      "install_opener": "Installa Opener",
      "repair_cables": "Riparazione cavi",
      "repair_garage_door": "Riparazione porte garage",
      "repair_gate": "Riparazione cancelli",
      "repair_rollers_tracks": "Riparazione di rulli e cingoli",
      "replace_door_panels": "Sostituisci i pannelli delle porte",
      "replace_opener": "Sostituzione apriporta",
      "replace_springs": "Sostituzione molle",
      "accessory_buildings": "Edifici accessori",
      "bathroom_remodel": "Ristrutturazione bagni",
      "decks_patio": "Terrazze e patio",
      "exterior_finishing": "Finitura esterna",
      "foundations_concrete": "Fondazioni e calcestruzzo",
      "general_contractor_commercial_projects": "Progetti commerciali",
      "general_contractor_other": "Altro",
      "home_addition": "Ampliamento di case",
      "home_building": "Costruzione di case",
      "home_remodel_renovation": "Ristrutturazione e rinnovamento di case",
      "interior_finishing": "Finitura interna",
      "kitchen_remodel": "Ristrutturazione cucine",
      "roofing": "Tetti e coperture",
      "assemble_furniture": "Assemblaggio mobili",
      "clean_gutters": "Pulizia grondaie",
      "handyman_other": "Altro",
      "install_drywall": "Installa il cartongesso",
      "install_flooring": "Installazione pavimentazione",
      "install_tile": "Posa piastrelle",
      "install_water_fixtures": "Installazione accessori idraulici",
      "mount_tv": "Montaggio TV",
      "paint_indoors": "Pittura interna",
      "paint_outdoors": "Pittura esterna",
      "repair_drywall": "Riparazione muri a secco",
      "repair_flooring": "Riparazione pavimenti",
      "repair_water_fixtures": "Riparazione impianti idraulici",
      "replace_tile": "Sostituzione piastrelle",
      "buyer_seller_inspection": "Ispezione acquirente-venditore",
      "commercial_properties": "Proprietà commerciali",
      "fire_safety": "Sicurezza antincendio",
      "fireplace_chimney": "Camino e canna fumaria",
      "full_home_inspection": "Ispezione completa della casa",
      "home_inspector_electrical": "Elettrico",
      "home_inspector_foundation": "Fondazione",
      "home_inspector_hvac": "HVAC",
      "home_inspector_mold": "Muffa",
      "home_inspector_new_construction": "Nuova costruzione",
      "home_inspector_other": "Altro",
      "home_inspector_plumbing": "Idraulica",
      "home_inspector_roof": "Tetto",
      "home_inspector_structural": "Strutturale",
      "home_warranty": "Garanzia domestica",
      "water_testing": "Analisi dell'acqua",
      "well_or_septic_system": "Pozzo o sistema settico",
      "wood_insects": "Legno e insetti",
      "access_control": "Controllo accessi",
      "alarm_systems": "Sistemi di allarme",
      "commercial_security_systems": "Sistemi di sicurezza commerciali",
      "fire_smoke_detection": "Rilevazione di incendi e fumo",
      "home_security_doors": "Porte",
      "home_security_locks": "Serrature",
      "home_security_other": "Altro",
      "home_security_windows": "Finestre",
      "monitoring_services": "Servizi di monitoraggio",
      "residential_security_systems": "Sistemi di sicurezza residenziali",
      "smart_home_integration": "Integrazione casa intelligente",
      "video_surveillance": "Videosorveglianza",
      "audio_video_installation": "Installazione Audio Video",
      "commercial_projects": "Progetti commerciali",
      "home_theater_design": "Progettazione di home theater",
      "home_theater_lighting": "Illuminazione",
      "home_theater_other": "Altro",
      "home_theater_smart_home_integration": "Integrazione casa intelligente",
      "install_tv": "Installazione TV",
      "network_it_services": "Servizi di rete e IT",
      "outdoor_installations": "Installazioni all'aperto",
      "soundproofing": "Insonorizzazione",
      "whole_house_audio_video": "Video audio casa intera",
      "ac_maintenance": "Manutenzione dell'aria condizionata",
      "clean_ducts_vents": "Pulizia condotti e prese d'aria",
      "ductless_heating_and_ac_services": "Servizi di riscaldamento e condizionamento senza condutture",
      "heating_maintenance": "Manutenzione del riscaldamento",
      "hvac_maintenance": "Manutenzione HVAC",
      "hvac_other": "Altro",
      "install_ac": "Installazione AC",
      "install_ducts_vents": "Installazione condotti e prese d'aria",
      "install_heating_system": "Installazione sistemi di riscaldamento",
      "install_thermostat": "Installazione termostato",
      "repair_ac": "Riparazione AC",
      "repair_ducts_vents": "Riparazione condotti e prese d'aria",
      "repair_heating_system": "Ripara il sistema di riscaldamento",
      "repair_hvac": "Riparazione HVAC",
      "repair_thermostat": "Ripara il termostato",
      "asylum": "Asilo",
      "citizenship": "Cittadinanza",
      "deportation": "Deportazione",
      "family_based_immigration": "Immigrazione per motivi familiari",
      "green_card": "Green Card",
      "immigration_lawyer_other": "Altro",
      "investment_visa": "Visto per investimenti",
      "outbound_work_permits": "Permessi di lavoro in uscita",
      "student_visa": "Visto per studenti",
      "visitor_visa": "Visto per visitatori",
      "work_visa": "Visto di lavoro",
      "appliance_selection": "Selezione elettrodomestici",
      "cabinetry_molding_hardware_design": "Progettazione di mobili e hardware",
      "decorating": "Decorazione",
      "door_design": "Design delle porte",
      "exterior_building_design": "Progettazione esterna degli edifici",
      "flooring_selection": "Scelta della pavimentazione",
      "interior_designer_other": "Altro",
      "landscaping_design": "Progettazione del paesaggio",
      "lighting_design": "Progettazione illuminotecnica",
      "multifamily_housing_design": "Progettazione di abitazioni multifamiliari",
      "room_planning": "Pianificazione delle stanze",
      "stone_brick_stucco_design": "Progettazione in pietra, mattoni e stucco",
      "window_design": "Progettazione di finestre",
      "advertisements": "Pubblicità",
      "copyright": "Diritti d'autore",
      "export_control": "Controllo delle esportazioni",
      "franchises": "Franchising",
      "international_ip": "IP internazionale",
      "ip_lawyer_other": "Altro",
      "ip_strategy": "Strategia IP",
      "ip_transactions": "Transazioni IP",
      "licensing": "Licenze",
      "litigation_ip_lawyer": "Contenzioso",
      "non_disclosure_agreements_ip_lawyer": "Accordi di non divulgazione",
      "patents": "Brevetti",
      "technology_transfer": "Trasferimento tecnologico",
      "trade_secrets": "Segreti commerciali",
      "trademarks": "Marchi",
      "appliance_removal": "Rimozione elettrodomestici",
      "construction_waste_removal": "Rimozione rifiuti da costruzione",
      "donation_pickup": "Ritiro donazioni",
      "electronic_waste_removal": "Rimozione dei Rifiuti Elettronici",
      "furniture_removal": "Rimozione mobili",
      "general_junk_removal": "Rimozione generale di rifiuti",
      "hazardous_waste_removal": "Rimozione di rifiuti pericolosi",
      "house_garage_cleanout": "Pulizia di casa/garage",
      "junk_removal_other": "Altro",
      "yard_waste_removal": "Rimozione rifiuti da giardino",
      "employment_contracts_labor_lawyer": "Contratti di lavoro",
      "employment_law_labor_lawyer": "Diritto del lavoro",
      "exempt_employee_status": "Status di dipendente esente",
      "labor_law": "Diritto del lavoro",
      "labor_lawyer_other": "Altro",
      "labor_negotiations": "Negoziazioni sindacali",
      "privacy_rights": "Diritti alla privacy",
      "sexual_harassment": "Molestie sessuali",
      "unpaid_overtime": "Straordinari non retribuiti",
      "whistle_blowing": "Whistleblowing",
      "workers_compensation_labor_lawyer": "Risarcimento per infortunio sul lavoro",
      "wrongful_termination": "Cessazione ingiustificata del rapporto di lavoro",
      "artificial_turf_installation": "Installazione di erba sintetica",
      "concrete_masonry": "Griglia a muratura in calcestruzzo",
      "driveway_landscaping": "Progettazione del vialetto d'accesso",
      "garden_decorations": "Decorazioni da giardino",
      "grading_resloping": "Livellamento e riprofilatura",
      "hardscapes": "Pavimentazioni",
      "landscape_design": "Progettazione del paesaggio",
      "landscape_installations": "Installazioni paesaggistiche",
      "landscaper_other": "Altro",
      "outdoor_steps": "Gradini all'aperto",
      "outdoor_water_feature": "Giochi d'acqua all'aperto",
      "paving_driveway_walkway": "Pavimentazione carrabile o pedonale",
      "retaining_walls": "Muri di contenimento",
      "sidewalk_walkway_landscaping": "Paesaggistica del passaggio pedonale",
      "sod_seeding": "Posa di zolle e semina",
      "stone_masonry": "Muratura in pietra",
      "arabic": "Arabo",
      "english": "English",
      "french": "French",
      "german": "German",
      "hebrew": "Ebraico",
      "italian": "Italian",
      "japanese": "Giapponese",
      "korean": "Coreano",
      "language_instructor_other": "Altro",
      "mandarin": "Mandarino",
      "portuguese": "Portoghese",
      "russian": "Russo",
      "sign_language": "Lingua dei segni",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Riparazione / Manutenzione sistemi di irrigazione",
      "lawn_care_other": "Altro",
      "lawn_mowing_maintenance": "Falciatura / Manutenzione del prato",
      "lawn_pest_control": "Disinfestazione del prato",
      "mulching": "Pacciamatura",
      "seeding": "Semina",
      "sod_installation": "Installazione di zolle",
      "weed_control": "Controllo delle erbacce",
      "yard_cleanup": "Pulizia del cortile",
      "appeals": "Ricorsi",
      "case_assessment_litigation_lawyer": "Valutazione del caso",
      "civil_litigation": "Contenzioso civile",
      "commercial_litigation": "Contenzioso commerciale",
      "contracts_and_agreements": "Contratti e Accordi",
      "criminal_litigation": "Contenzioso penale",
      "litigation_lawyer_other": "Altro",
      "mediation_litigation_lawyer": "Mediazione",
      "settlements": "Pagamenti",
      "building_lockout": "Accesso bloccato all'edificio",
      "copy_building_key": "Copia chiavi edificio",
      "copy_vehicle_key": "Copia chiavi veicolo",
      "install_hardware": "Installazione hardware",
      "locksmith_other": "Altro",
      "new_key_fob": "Nuova chiave elettronica",
      "rekey_lock": "Riprogrammazione serratura",
      "repair_hardware": "Riparazione hardware",
      "vehicle_lockout": "Accesso bloccato al veicolo",
      "consent_issues": "Problemi di consenso",
      "diagnosis_errors": "Errori di diagnosi",
      "malpractice_lawyer_other": "Altro",
      "medical_negligence": "Negligenza medica",
      "treatment_errors": "Errori di trattamento",
      "massage_center_other": "Altro",
      "massage_school_advanced_neuromuscular_therapy": "Terapia neuromuscolare avanzata",
      "massage_school_business_and_ethics": "Impresa ed etica",
      "massage_school_clinical_therapies": "Terapie cliniche",
      "massage_school_continuing_education": "Formazione continua",
      "massage_school_deep_tissue_massage": "Massaggio dei tessuti profondi",
      "massage_school_energetics": "Energetica",
      "massage_school_hydrotherapy": "Idroterapia",
      "massage_school_lymphatic_massage": "Massaggio linfatico",
      "massage_school_online_massage_therapy": "Massaggi online",
      "massage_school_other": "Altro",
      "massage_school_prenatal_massage": "Massaggio prenatale",
      "massage_school_sports_massage": "Massaggio sportivo",
      "massage_school_student_massage_clinic": "Massaggio eseguito da studenti",
      "massage_school_swedish_massage": "Massaggio svedese",
      "massage_theory": "Teoria del massaggio",
      "massage_therapy_training": "Corsi di massaggio",
      "in_state_move": "Trasferimento all'interno dello stato",
      "local_move": "Trasferimento locale",
      "mover_other": "Altro",
      "moving_junk_removal": "Rimozione di rifiuti",
      "moving_storage": "Deposito",
      "out_of_state_move": "Trasferimento fuori dallo stato",
      "oversized_item_move": "Spostamento di oggetti di grandi dimensioni",
      "packing_unpacking": "Imballaggio / Disimballaggio",
      "senior_move": "Trasferimento anziani",
      "vehicle_transport": "Trasporto di veicoli",
      "cardiac_care": "Cura cardiaca",
      "general_medical_care": "Cure mediche generali",
      "hospice": "Hospice",
      "iv_therapy": "Terapia endovenosa",
      "nursing_home_meal_services": "Servizi per i pasti",
      "nursing_home_memory_care": "Cura della memoria",
      "nursing_home_other": "Altro",
      "nursing_home_pain_management": "Gestione del dolore",
      "nursing_home_rehabilitation_services": "Servizi di riabilitazione",
      "nursing_home_wellness_programs": "Programmi benessere",
      "outpatient_rehabilitation": "Riabilitazione Ambulatoriale",
      "post_hospital_care": "Assistenza post-ospedaliera",
      "respiratory_and_pulmonary_care": "Cure respiratorie e polmonari",
      "senior_activity_programs": "Programmi di attività per anziani",
      "short_term_rehabilitation": "Riabilitazione a breve termine",
      "wound_care": "Cura delle ferite",
      "exterior_painting": "Pittura Esterna",
      "interior_painting": "Pittura d'interni",
      "paint_cabinets": "Verniciatura armadi",
      "paint_doors": "Verniciatura porte",
      "painter_other": "Altro",
      "repair_water_damage": "Riparazione danni causati dall'acqua",
      "staining": "Tinteggiatura",
      "assault_battery": "Aggressione e percosse",
      "auto_accidents": "Incidenti automobilistici",
      "bicycle_accidents": "Incidenti in bicicletta",
      "catastrophic_injuries": "Lesioni catastrofiche",
      "dog_bites": "Morsi di cane",
      "dui_injuries_personal_injury_lawyer": "Infortuni da guida in stato di ebbrezza",
      "medical_malpractice": "Negligenza medica",
      "motorcycle_accidents": "Incidenti motociclistici",
      "pain_suffering": "Dolore e sofferenza",
      "pedestrian_accidents": "Incidenti pedonali",
      "personal_injury_lawyer_other": "Altro",
      "product_liability": "Responsabilità del prodotto",
      "slip_fall": "Scivolate e cadute",
      "uninsured_motorist_claims": "Reclami assicurativi automobilisti",
      "workers_compensation_personal_injury_lawyer": "Risarcimento per infortunio sul lavoro",
      "wrongful_death": "Omicidio colposo",
      "aerobics": "Aerobica",
      "athletic_performance": "Prestazioni atletiche",
      "circuit_training": "Allenamento a circuito",
      "endurance": "Resistenza",
      "fitness_assessment": "Valutazione di idoneità",
      "hiit": "HIIT",
      "nutritional_counseling": "Consulenza nutrizionale",
      "personal_trainer_other": "Altro",
      "strength_conditioning": "Forza e preparazione atletica",
      "weight_loss": "Perdita di peso",
      "yoga": "Yoga",
      "ants": "Formiche",
      "bed_bugs": "Cimici dei letti",
      "bees": "Api",
      "cockroaches": "Scarafaggi",
      "fleas_or_mites": "Pulci o acari",
      "hornets_or_wasps": "Calabroni o vespe",
      "mosquitoes": "Zanzare",
      "pest_control_other": "Altro",
      "pest_inspection": "Ispezione",
      "rodents": "Roditori",
      "spiders": "Ragni",
      "termites": "Termiti",
      "wildlife": "Fauna selvatica",
      "pet_adoption_birds": "Uccelli",
      "pet_adoption_cats": "Gatti",
      "pet_adoption_dogs": "Cani",
      "pet_adoption_farm_animals": "Animali da fattoria",
      "pet_adoption_fish": "Pesci",
      "pet_adoption_other": "Altro",
      "pet_adoption_reptiles": "Rettili",
      "pet_adoption_small_mammals": "Piccoli mammiferi",
      "pet_adoption_special_needs_animals": "Animali con esigenze speciali",
      "cat_boarding": "Pensione per gatti",
      "cat_grooming": "Toelettatura per gatti",
      "cat_sitting_in_home": "Cat sitting (a domicilio)",
      "dog_boarding": "Pensione per cani",
      "dog_boarding_with_training": "Pensione per cani con addestramento",
      "dog_daycare": "Asilo per cani",
      "dog_grooming": "Toelettatura cani",
      "dog_sitting_in_home": "Dog sitting (a domicilio)",
      "dog_training": "Addestramento cani",
      "dog_walking": "Passeggiate con il cane",
      "other_pet_boarding": "Altra pensione per animali domestici",
      "other_pet_daycare": "Altri servizi di assistenza per animali domestici",
      "other_pet_grooming": "Altra toelettatura per animali domestici",
      "other_pet_sitting_in_home": "Altri servizi di pet sitter (in casa)",
      "pet_boarding_other": "Altro",
      "cat_bathing": "Bagno del gatto",
      "cat_ear_cleaning": "Pulizia delle orecchie del gatto",
      "cat_grooming_and_styling": "Toelettatura e styling gatti",
      "cat_nail_trimming": "Taglio delle unghie del gatto",
      "dog_anal_gland_expression": "Liberazione della ghiandola anale del cane",
      "dog_bathing_and_blow_dry": "Bagno e asciugatura cani",
      "dog_ear_cleaning": "Pulizia delle orecchie del cane",
      "dog_flea_and_tick_treatment": "Trattamento pulci e zecche del cane",
      "dog_full_service_grooming": "Toelettatura a servizio completo per cani",
      "dog_grooming_and_styling": "Toelettatura e styling cani",
      "dog_nail_trimming": "Taglio delle unghie del cane",
      "dog_teeth_brushing": "Pulizia dentale per cani",
      "pet_grooming_other": "Altro",
      "aggressive_dog_training": "Addestramento per cani aggressivi",
      "behavior_modification": "Modifica del comportamento",
      "obedience_training": "Addestramento all'obbedienza",
      "offleash_training": "Addestramento senza guinzaglio",
      "pet_trainer_other": "Altro",
      "puppy_training": "Addestramento cuccioli",
      "service_animal_training": "Addestramento di animali di servizio",
      "sport_trick_training": "Allenamento sportivo o di abilità",
      "training_other_animals": "Addestramento per altri animali",
      "corporate_photo": "Aziendale",
      "events_and_parties_photo": "Eventi e feste",
      "family_and_group_photo": "Famiglia e comunità",
      "headshots_and_portraits": "Ritratti e foto ritratto",
      "individual_photo": "Individuale",
      "maternity_and_newborn_photo": "Maternità e neonati",
      "photographer_other": "Altro",
      "product_photo": "Prodotto",
      "real_estate_photo": "Immobili",
      "school_portraits": "Ritratti scolastici",
      "wedding_and_engagement_photo": "Matrimonio e fidanzamento",
      "find_leak": "Individuazione e riparazione perdite",
      "install_faucet": "Installazione rubinetto",
      "install_garbage_disposal": "Installa il tritarifiuti",
      "install_shower": "Installazione doccia",
      "install_toilet": "Installazione WC",
      "install_water_heater": "Installazione scaldabagno",
      "plumbing_other": "Altro",
      "repair_faucet": "Ripara il rubinetto",
      "repair_garbage_disposal": "Riparazione tritarifiuti",
      "repair_outdoor_systems": "Riparazione di sistemi esterni",
      "repair_pipe": "Ripara il tubo",
      "repair_sewer": "Riparazione fogna",
      "repair_shower": "Ripara la doccia",
      "repair_toilet": "Riparazione WC",
      "repair_water_heater": "Riparazione scaldabagno",
      "unclog_drain": "Sturare lo scarico",
      "commercial_pool_cleaning_maintenance": "Pulizia e manutenzione di piscine commerciali",
      "equipment_maintenance_repair": "Riparazione e manutenzione attrezzature",
      "one_time_pool_cleaning": "Pulizia una tantum della piscina",
      "ongoing_pool_cleaning": "Pulizia continua della piscina",
      "pool_cleaner_other": "Altro",
      "pool_cleaner_water_features": "Giochi d'acqua",
      "seasonal_opening_closing": "Apertura e chiusura stagionale",
      "spa_hot_tub_cleaning": "Pulizia di spa e vasche idromassaggio",
      "spa_hot_tub_repairs": "Riparazione di spa e vasche idromassaggio",
      "tile_pool_wall_cleaning": "Pulizia delle piastrelle e delle pareti della piscina",
      "water_testing_balancing": "Analisi e bilanciamento dell'acqua",
      "jetted_lap_pools": "Piscine con getti per nuoto",
      "pool_construction": "Costruzione di piscine",
      "pool_contractor_commercial_projects": "Progetti commerciali",
      "pool_contractor_custom_designs": "Design personalizzati",
      "pool_contractor_other": "Altro",
      "pool_contractor_renovation": "Ristrutturazione",
      "pool_contractor_repair_cracks": "Riparazione crepe",
      "pool_contractor_repair_tile": "Riparazione piastrelle",
      "pool_contractor_resurfacing": "Rifacimento superficie",
      "pool_contractor_water_features": "Giochi d'acqua",
      "pool_hot_tub_equipment": "Attrezzature per piscine e vasche idromassaggio",
      "spa_hot_tub_installation": "Installazione di spa e vasca idromassaggio",
      "bilingual_programs": "Programmi bilingue",
      "early_preschool": "Scuola dell'infanzia",
      "full_day_preschool": "Scuola dell'infanzia a tempo pieno",
      "half_day_preschool": "Scuola dell'infanzia a mezza giornata",
      "kindergarten_classes": "Corsi scuola materna",
      "montessori_programs": "Programmi Montessori",
      "play_based_preschool": "Scuola dell'infanzia basata sul gioco",
      "preschool_infant_programs": "Programmi per l'infanzia",
      "preschool_other": "Altro",
      "reggio_emilia_preschool": "Scuola dell'infanzia Reggio Emilia",
      "special_needs_programs": "Programmi per bisogni speciali",
      "summer_camp": "Campo estivo",
      "waldorf_preschool": "Scuola dell'infanzia Waldorf",
      "psychologist_other": "Altro",
      "buyer_agent": "Agente dell'Acquirente",
      "first_time_home_buyer": "Acquirente di casa per la prima volta",
      "foreclosed_properties": "Proprietà pignorate",
      "luxury_properties": "Proprietà di lusso",
      "new_construction": "Nuova costruzione",
      "property_management": "Gestione proprietà",
      "real_estate_agent_other": "Altro",
      "relocation": "Trasloco",
      "rentals": "Affitti",
      "sellers_agent": "Agente del venditore",
      "commercial_real_estate": "Immobili commerciali",
      "easements": "Servitù",
      "encroachment": "Intrusione",
      "foreclosure_real_esate_lawyer": "Pignoramento",
      "landlord_tenant_law": "Diritto dei proprietari e degli inquilini",
      "litigation_real_estate_lawyer": "Contenzioso",
      "mortgage_lending_law": "Legge sui mutui e sui prestiti",
      "neighbor_hoa_disputes": "Controversie tra vicini e HOA",
      "property_damage": "Danni alla proprietà",
      "purchase_agreements": "Contratti di acquisto",
      "real_estate_contracts_transactions": "Vendite immobiliari",
      "real_estate_lawyer_other": "Altro",
      "residential_real_estate": "Immobili residenziali",
      "title_services": "Servizi di trasferimento proprietà",
      "trespassing": "Violazione di domicilio",
      "rehab_other": "Altro",
      "attic_venting": "Ventilazione dell'attico",
      "gutter_installation": "Installazione grondaie",
      "gutter_repair": "Riparazione grondaie",
      "roof_inspection": "Ispezione del tetto",
      "roof_installation": "Installazione tetto",
      "roof_repair": "Riparazione del tetto",
      "roofer_other": "Altro",
      "skylight_installation": "Installazione di lucernari",
      "skylight_repair": "Riparazione lucernari",
      "storm_wind_damage_roof_repair": "Riparazione danni al tetto",
      "sewage_cleaning": "Pulizia",
      "sewage_excavation": "Scavo",
      "sewage_inspection": "Ispezione",
      "sewage_installation": "Installazione",
      "sewage_locating": "Localizzazione",
      "sewage_maintenance_repairs": "Manutenzione e riparazioni",
      "sewage_pro_other": "Altro",
      "sewage_pumping": "Pompaggio",
      "sewage_removal_demolition": "Rimozione o demolizione",
      "remodeling_siding_pro": "Ristrutturazione",
      "repair_maintenance_siding_pro": "Riparazione e manutenzione",
      "siding_installation": "Installazione rivestimenti",
      "siding_pro_other": "Altro",
      "siding_removal": "Rimozione del rivestimento",
      "smart_home_other": "Altro",
      "commercial_snow_removal": "Rimozione neve commerciale",
      "residential_plowing": "Sgombero neve residenziale",
      "residential_shoveling_blowing": "Spalatura residenziale e soffiaggio",
      "salt_sand_deicing": "Sabbia salina e sbrinamento",
      "snow_relocation": "Trasferimento neve",
      "snow_removal_other": "Altro",
      "body_polish": "Trattamento esfoliante per il corpo",
      "body_wrap": "Impacco per il corpo",
      "facial": "Trattamento viso",
      "hydrotherapy": "Idroterapia",
      "manicure": "Manicure",
      "massage": "Massaggio",
      "pedicure": "Pedicure",
      "peels": "Peeling",
      "spa_other": "Altro",
      "spa_packages": "Pacchetti Spa",
      "tanning": "Abbronzatura",
      "waxing": "Ceretta",
      "civil_tax_litigation": "Contenzioso fiscale civile",
      "corporate_taxes": "Imposte societarie",
      "criminal_tax_litigation": "Contenzioso fiscale penale",
      "estate_tax_planning": "Pianificazione finanziaria per la successione",
      "failure_to_file": "Mancata presentazione del documento",
      "innocent_spouse_relief": "Sollievo per coniugi innocenti",
      "international_tax_services": "Servizi di fiscalità internazionale",
      "irs_tax_problems": "Problemi fiscali con l'IRS",
      "non_collectible_status": "Stato non esigibile",
      "offer_in_compromise": "Offerta in compromesso",
      "tax_audits": "Verifiche fiscali",
      "tax_lawyer_other": "Altro",
      "tax_liens_levies": "Privilegi e prelievi fiscali",
      "tax_planning_lawyer": "Pianificazione fiscale",
      "tax_relief": "Agevolazione fiscale",
      "accounting_support": "Supporto contabile",
      "business_incorporation_restructuring": "Incorporazione e ristrutturazione",
      "cryptocurrency_taxes": "Tasse sulle criptovalute",
      "irs_audit_representation": "Rappresentanza per audit dell'IRS",
      "irs_filing": "Dichiarazione IRS",
      "irs_problem_consulting": "Consulenza su problemi IRS",
      "new_business_services": "Nuovi servizi aziendali",
      "payroll_support": "Supporto per le buste paga",
      "tax_planning_tax_specialist": "Pianificazione fiscale",
      "tax_preparation": "Preparazione delle tasse",
      "tax_problem_consulting_tax_specialist": "Consulenza problematiche fiscali",
      "tax_specialist_other": "Altro",
      "therapist_other": "Altro",
      "battery_service": "Servizio batterie",
      "car_towing": "Traino auto",
      "fuel_delivery": "Consegna carburante",
      "local_hauling": "Trasporto locale",
      "long_distance_hauling": "Trasporto a lunga distanza",
      "motorcycle_towing": "Traino moto",
      "special_vehicle_towing": "Traino di veicoli speciali",
      "tire_change": "Cambio gomme",
      "towing_other": "Altro",
      "case_assessment_traffic_lawyer": "Valutazione del caso",
      "cdl_traffic_ticket": "Multa stradale CDL",
      "dui_dwi_traffic_lawyer": "DUI",
      "fixit_ticket": "Multa Fix-it",
      "parking_ticket": "Multa parcheggio",
      "reckless_driving_traffic_lawyer": "Guida spericolata",
      "red_light_ticket": "Multa per semaforo rosso",
      "speeding_ticket": "Multa per eccesso di velocità",
      "suspended_license": "Licenza sospesa",
      "traffic_lawyer_other": "Altro",
      "traffic_ticket": "Contravvenzione",
      "cabling_and_bracing": "Cablaggio e rinforzo",
      "stump_removal": "Rimozione dei ceppi",
      "tree_planting": "Piantumazione alberi",
      "tree_removal": "Rimozione alberi",
      "tree_service_other": "Altro",
      "tree_transplanting": "Trapianto di alberi",
      "tree_trimming_and_pruning": "Potatura e taglio alberi",
      "tutor_computer_science": "Informatica",
      "tutor_foreign_languages": "Lingue straniere",
      "tutor_geography": "Geografia",
      "tutor_government_and_economics": "Governo ed economia",
      "tutor_history": "Storia",
      "tutor_homework_help": "Aiuto per i compiti",
      "tutor_math": "Matematica",
      "tutor_other": "Altro",
      "tutor_reading_and_writing": "Lettura e scrittura",
      "tutor_science": "Scienza",
      "tutor_special_education": "Formazione speciale",
      "tutor_test_pre_college_entrance": "Preparazione ai test: ingresso al college",
      "tutor_test_prep_grad_school_entrance": "Preparazione ai test: ingresso alla scuola di specializzazione",
      "tutor_test_prep_k8": "Preparazione ai test: K-8",
      "area_rug_cleaning": "Pulizia tappeti",
      "drapery_and_blind_cleaning": "Pulizia tendaggi e persiane",
      "leather_cleaning": "Pulizia della pelle",
      "mattress_cleaning": "Pulizia materassi",
      "upholstery_cleaner_other": "Altro",
      "upholstery_cleaning": "Pulizia rivestimenti",
      "upholstery_water_damage_cleanup": "Pulizia danni da acqua",
      "bird_exotic_animal_care": "Cura degli uccelli e degli animali esotici",
      "farm_barn_animal_care": "Cura degli animali da fattoria e da stalla",
      "microchipping": "Microchippatura",
      "veterinarian_allergies": "Allergie",
      "veterinarian_behavior_counseling": "Consulenza comportamentale",
      "veterinarian_dental_care": "Cure dentistiche",
      "veterinarian_dermatology": "Dermatologia",
      "veterinarian_emergency_care": "Assistenza di emergenza",
      "veterinarian_end_of_life_care": "Cure di fine vita",
      "veterinarian_examinations": "Esami",
      "veterinarian_nutrition_counseling": "Consulenza nutrizionale",
      "veterinarian_other": "Altro",
      "veterinarian_preventive_care": "Cura preventiva",
      "veterinarian_spay_neuter": "Sterilizzazione o castrazione",
      "veterinarian_surgery": "Chirurgia",
      "veterinarian_vaccinations": "Vaccinazioni",
      "aerial_videography": "Videografia aerea",
      "documentary_video_production": "Produzione documentari",
      "family_video_production": "Produzione video per famiglie",
      "live_streaming": "Diretta streaming",
      "photography": "Fotografia",
      "product_demonstrations": "Dimostrazione del prodotto",
      "promotional_video_production": "Produzione di video promozionali",
      "real_estate_video_production": "Produzione video immobiliare",
      "special_event_video_production": "Produzione video per eventi speciali",
      "video_editing": "Montaggio video",
      "videographer_other": "Altro",
      "voice_overs": "Doppiaggio",
      "wedding_video_production": "Produzione video di matrimonio",
      "fire_damage_cleanup_repair": "Pulizia/riparazione danni da incendio",
      "water_damage_cleanup_repair": "Pulizia dei danni causati dall'acqua",
      "water_damage_flooring": "Pavimentazione",
      "water_damage_mold_inspection": "Ispezione della muffa",
      "water_damage_mold_removal": "Rimozione della muffa",
      "water_damage_other": "Altro",
      "water_damage_painting": "Pittura",
      "water_damage_pest_control": "Controllo dei parassiti",
      "water_damage_plumbing": "Idraulica",
      "water_damage_remodeling": "Ristrutturazione",
      "water_damage_roofing": "Tetti e coperture",
      "water_damage_sewage_cleanup": "Pulizia delle acque reflue",
      "adult_weight_loss_programs": "Programmi di perdita di peso per adulti",
      "diet_and_nutrition_counseling": "Consulenza su dieta e nutrizione",
      "kids_weight_loss_programs": "Programmi di perdita di peso per bambini",
      "metabolic_testing": "Test metabolici",
      "weight_loss_consultation_and_training": "Consulenza e formazione",
      "weight_loss_fitness_programs": "Programmi di fitness",
      "weight_loss_meal_planning": "Pianificazione dei pasti",
      "weight_loss_personal_training": "Personal Training",
      "weight_loss_service_other": "Altro",
      "weight_loss_wellness_programs": "Programmi di benessere",
      "glass_and_mirror_cleaning": "Pulizia di vetri e specchi",
      "gutter_cleaning": "Pulizia delle grondaie",
      "power_pressure_washing": "Lavaggio a potenza/pressione",
      "rooftop_skylight_cleaning": "Pulizia di tetti/lucernari",
      "window_cleaner_other": "Altro",
      "window_cleaning": "Pulizia finestre",
      "door_installation": "Installazione della porta",
      "door_repair": "Riparazione porte",
      "glass_installation": "Installazione vetri",
      "window_boardup": "Copertura con assi di legno",
      "window_installation": "Installazione di finestre",
      "window_repair": "Riparazione finestre",
      "window_repair_other": "Altro",
      "install_new_wiper_blades": "Installa nuove spazzole tergicristallo",
      "repair_power_window": "Riparazione finestre elettriche",
      "repair_water_leak": "Riparazione perdita d'acqua",
      "repair_windshield": "Riparazione parabrezza",
      "replace_rear_window": "Sostituzione lunotto posteriore",
      "replace_side_view_mirrors": "Riparazione specchietti retrovisori laterali",
      "replace_side_window": "Sostituzione finestrino laterale",
      "replace_sunroof": "Sostituisci il vetro del tettuccio apribile",
      "replace_windshield": "Sostituzione parabrezza",
      "windshield_other": "Altro",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot Yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditazione",
      "power_yoga": "Power Yoga",
      "restorative": "Ristoratore",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Altro"
    }
  }
}
